"use strict";
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createAskPassword(containerEl, deps) {
                const { confirmAskPasswordAsync, sendPasswordAsync, showLoadingDialog } = deps;
                const formEl = eXpress.html.querySelector(containerEl, ".technical-ask-password-form", true);
                const sendPassWordLinkEl = eXpress.html.querySelector(containerEl, ".technical-send-password-link", true);
                const sendPasswordLinkClick = (e) => {
                    e.preventDefault();
                    const email = sendPassWordLinkEl.dataset.email;
                    email && sendPasswordAsync(email);
                };
                const askPasswordForm = components.main.initForm(formEl, {
                    onSubmitForm: (formData) => showLoadingDialog ? confirmAskPasswordAsync(formData["password"]) : eXpress.utils.showLoadingDialog(confirmAskPasswordAsync(formData["password"])),
                    submitOnEnter: true
                });
                sendPassWordLinkEl.addEventListener('click', sendPasswordLinkClick);
                return {
                    dispose: () => {
                        askPasswordForm.dispose();
                        sendPassWordLinkEl.removeEventListener('click', sendPasswordLinkClick);
                    }
                };
            }
            main.createAskPassword = createAskPassword;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            // generic 
            function createClickableElement(el, onClick, options = {}) {
                let clickEvent;
                const { enable, disable } = options;
                const onClicked = (e) => {
                    e.preventDefault();
                    if (onClick) {
                        dispose();
                        disable && disable();
                        onClick()
                            .then(() => {
                            enable && enable();
                            addClickEvent();
                        });
                    }
                };
                const addClickEvent = () => { clickEvent = eXpress.html.addEventListener(el, 'click', onClicked); };
                const dispose = () => clickEvent.dispose();
                addClickEvent();
                return {
                    addClickEvent,
                    dispose
                };
            }
            main.createClickableElement = createClickableElement;
            // UX-button specific
            // http://brandplatform.smartphoto.com/general/atoms/button/
            function createButton(buttonEl, onClick) {
                const enable = () => {
                    eXpress.html.removeClass(buttonEl, "a-button--disabled");
                    buttonEl.removeAttribute("disabled");
                };
                const disable = () => {
                    eXpress.html.addClass(buttonEl, "a-button--disabled");
                    buttonEl.setAttribute("disabled", "disabled");
                };
                const button = createClickableElement(buttonEl, onClick, {
                    enable,
                    disable
                });
                return {
                    dispose: button.dispose,
                    enable,
                    disable
                };
            }
            main.createButton = createButton;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createCollapsable(container, deps) {
                const { onBeforeOpen, onBeforeClose, titleElSelector, scrollIntoViewAfterOpen } = deps;
                const OPEN_CLASS = "is-collapse-open";
                const titleEl = eXpress.html.querySelector(container, titleElSelector, true);
                const closeWithBefore = () => {
                    if (!onBeforeClose) {
                        close();
                        return $.Deferred().resolve().promise();
                    }
                    return onBeforeClose().then(() => close());
                };
                const openWithBefore = (scrollIntoView = false) => {
                    if (!onBeforeOpen) {
                        open();
                        return $.Deferred().resolve().promise();
                    }
                    return onBeforeOpen().then(() => open(scrollIntoView));
                };
                const close = () => container.classList.remove(OPEN_CLASS);
                const open = (scrollIntoView) => {
                    container.classList.add(OPEN_CLASS);
                    if (scrollIntoViewAfterOpen || scrollIntoView)
                        titleEl.scrollIntoView({ behavior: "smooth", block: "start" });
                };
                const isOpen = () => eXpress.html.hasClass(container, OPEN_CLASS);
                const onClick = () => !isOpen() ? openWithBefore() : closeWithBefore();
                const button = components.main.createClickableElement(titleEl, onClick);
                return {
                    dispose: button.dispose,
                    show: () => container.classList.remove('u-hide'),
                    hide: () => container.classList.add('u-hide'),
                    close,
                    open: (scrollIntoView) => openWithBefore(scrollIntoView),
                    isOpen
                };
            }
            main.createCollapsable = createCollapsable;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initCountDown(containerEl, el, countDownToDate, opts) {
                const { showDays, onCountDownFinish, daysLabel, dayLabel } = opts;
                const toDate = (input) => {
                    const dateString = input.split(' ')[0];
                    const timeString = input.split(' ')[1];
                    const day = parseInt(dateString.split('/')[0], 10);
                    const month = parseInt(dateString.split('/')[1], 10) - 1;
                    const year = parseInt(dateString.split('/')[2], 10);
                    const hour = parseInt(timeString.split(':')[0], 10);
                    const minutes = parseInt(timeString.split(':')[1], 10);
                    const seconds = parseInt(timeString.split(':')[2], 10);
                    return new Date(year, month, day, hour, minutes, seconds, 0);
                };
                const pad = (num, size) => {
                    let temp = num.toString();
                    while (temp.length < size)
                        temp = "0" + temp;
                    return temp;
                };
                const countDownTime = toDate(countDownToDate).getTime();
                const countDown = () => {
                    const now = new Date().getTime();
                    const timeLeft = countDownTime - now;
                    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
                    let hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
                    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
                    if (timeLeft > 0) {
                        if (!showDays || !daysLabel || !dayLabel) {
                            hours = hours + (days * 24);
                            el.innerHTML = pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
                        }
                        else {
                            if (days > 1)
                                el.innerHTML = days + ' ' + daysLabel + ' ' + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
                            else if (days === 1)
                                el.innerHTML = days + ' ' + dayLabel + ' ' + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
                            else
                                el.innerHTML = pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
                        }
                    }
                    else {
                        if (onCountDownFinish)
                            onCountDownFinish();
                    }
                };
                setInterval(countDown, 1000);
            }
            main.initCountDown = initCountDown;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createCountrySelection(deps) {
                let onClickDisposable;
                const init = () => {
                    deps.showCountrySelectionPopup().then(() => {
                        const countrySelectionPopup = eXpress.html.querySelector(document, '#country-selection');
                        if (countrySelectionPopup) {
                            const continueButton = eXpress.html.querySelector(countrySelectionPopup, '.technical-countryselection');
                            if (continueButton) {
                                if (continueButton.dataset.countryselectionlink) {
                                    const navigateToLink = continueButton.dataset.countryselectionlink.toLowerCase();
                                    attachOnClick(continueButton, () => navigateTo(navigateToLink));
                                }
                            }
                        }
                    });
                };
                const navigateTo = (navigateToLink) => {
                    if (navigateToLink)
                        document.location.href = navigateToLink;
                    deps.close();
                };
                const attachOnClick = (button, ev) => (onClickDisposable = eXpress.html.addEventListener(button, 'click', ev));
                const detachClick = () => onClickDisposable && onClickDisposable.dispose();
                init();
                return {
                    dispose: () => {
                        detachClick();
                    }
                };
            }
            main.createCountrySelection = createCountrySelection;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            let EternalSlidingMode;
            (function (EternalSlidingMode) {
                EternalSlidingMode[EternalSlidingMode["Infinite"] = 0] = "Infinite";
                EternalSlidingMode[EternalSlidingMode["ScrollToBegin"] = 1] = "ScrollToBegin";
            })(EternalSlidingMode = main.EternalSlidingMode || (main.EternalSlidingMode = {}));
            function createCustomSlider(element, settings) {
                // prop to move div from left to right
                let sliderPxX = 0;
                let widthBeforeResize = 0;
                // slider elements
                let sliderEl;
                let elementsEl;
                let firstVisibleElement;
                let prevButton;
                let nextButton;
                // properties for sliding
                let mouseDownOnSlider = false;
                let startSliderDragX = 0;
                let startSliderDragY = 0;
                let currentSliderDragX = 0;
                let isDragged = false;
                let preventPageScrolling = false;
                let preventSliderDragging = false;
                let prevSliderWidth = 0;
                // private methods
                const init = function (element, replaceWithElement) {
                    if (ioSlider && !settings.forceRenderSlider) {
                        ioSlider.observe(element);
                    }
                    else {
                        // create slider template
                        sliderEl = getSliderTemplate();
                        // append slider to HTML
                        if (replaceWithElement && element.parentElement)
                            element.parentElement.replaceChild(sliderEl, element);
                        else
                            element.appendChild(sliderEl);
                        // trigger initialized event
                        if (settings.InitializedEvent)
                            settings.InitializedEvent(settings, sliderEl);
                        // to check if the buttons should be disabled or not
                        checkEdgesAndMove(0);
                        addHandlers();
                        resizeObserver.observe(elementsEl);
                    }
                };
                const dispose = () => {
                    prevButton && prevButton.removeEventListener('click', previousEvent);
                    nextButton && nextButton.removeEventListener('click', nextEvent);
                    if (sliderEl) {
                        sliderEl.removeEventListener('mousedown', (e) => {
                            e.preventDefault();
                            dragStart(e);
                        });
                        sliderEl.removeEventListener('touchstart', dragStart);
                        if (isTouchDevice()) {
                            sliderEl.removeEventListener('touchend', dragStop);
                            sliderEl.removeEventListener('touchmove', dragging);
                            sliderEl.removeEventListener('touchcancel', dragLeave);
                            return;
                        }
                        sliderEl.removeEventListener('mousemove', dragging);
                        sliderEl.removeEventListener('mouseleave', dragLeave);
                        sliderEl.removeEventListener('mouseup', dragStop);
                    }
                    if (window) {
                        window.removeEventListener('scroll', scrollStart);
                    }
                };
                const addHandlers = () => {
                    prevButton && prevButton.addEventListener('click', previousEvent);
                    nextButton && nextButton.addEventListener('click', nextEvent);
                    // add event listeners of slider
                    addSliderEventListeners();
                };
                const resizeObserver = new ResizeObserver((entries) => {
                    for (const entry of entries)
                        if (entry.contentRect && entry.target)
                            // Do not resize if the sliders is within a popup (it will resize when opening or closing the popup) or isn't visible on the page
                            if (eXpress.html.isElementFullyVisible(entry.target)
                                || eXpress.html.hasClass(entry.target, "technical-emarsys-recommendation")
                                || eXpress.html.getParentWithClassName(entry.target, 'technical-emarsys-recommendation'))
                                resize();
                });
                // #region SliderEvents
                const isTouchDevice = () => ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
                const getSlideFromEventTarget = (target) => {
                    if (!(target instanceof Element))
                        return;
                    const slideElement = target.closest('.technical-slider-element');
                    if (!slideElement || !elementsEl.contains(slideElement))
                        return;
                    return settings.sliderElements.find(x => x.id === slideElement.id);
                };
                const isSliderButtonTarget = (target) => {
                    if (!(target instanceof Element))
                        return false;
                    return !!target.closest('.technical-slider-button');
                };
                const addSliderEventListeners = () => {
                    // add touch listeners when touch
                    if (isTouchDevice())
                        sliderTouchEventListeners();
                    sliderMouseEventListeners();
                };
                const sliderMouseEventListeners = () => {
                    // mouse events
                    elementsEl.addEventListener('mousedown', (e) => {
                        e.preventDefault();
                        dragStart(e);
                    });
                };
                const sliderTouchEventListeners = () => {
                    // touch events
                    // passive => opt-in to better scroll performance by eliminating the need for scrolling to block on touch and wheel event listeners
                    elementsEl.addEventListener('touchstart', dragStart, { passive: true });
                    window.addEventListener('scroll', scrollStart);
                };
                const resize = () => {
                    // Android/IOS triggers resize caused by scrolling (navigation bar goes away) => don't change anything when slider width is the same
                    const sliderWidth = getFullWidthElement(sliderEl);
                    if (prevSliderWidth === sliderWidth)
                        return;
                    prevSliderWidth = sliderWidth;
                    eXpress.utils.debounce(reset, 250)();
                };
                const preventClick = (e) => {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                };
                const scrollStart = () => {
                    preventSliderDragging = true;
                };
                // drag methods
                const dragStart = (e) => {
                    var _a, _b;
                    isDragged = false;
                    mouseDownOnSlider = true;
                    startSliderDragX = getPositionX(e);
                    startSliderDragY = getPositionY(e);
                    currentSliderDragX = startSliderDragX;
                    preventPageScrolling = false;
                    preventSliderDragging =
                        ((_a = prevButton === null || prevButton === void 0 ? void 0 : prevButton.classList.contains(settings.sliderContainerSettings.previousButton.cssWhenOnMax)) !== null && _a !== void 0 ? _a : true) &&
                            ((_b = nextButton === null || nextButton === void 0 ? void 0 : nextButton.classList.contains(settings.sliderContainerSettings.nextButton.cssWhenOnMax)) !== null && _b !== void 0 ? _b : true);
                    if (isTouchDevice()) {
                        sliderEl.addEventListener('touchend', dragStop, { passive: true });
                        sliderEl.addEventListener('touchmove', eXpress.utils.throttle(dragging, 100), { passive: false });
                        sliderEl.addEventListener('touchcancel', dragLeave, { passive: true });
                        return;
                    }
                    // mouse events
                    sliderEl.addEventListener('mousemove', (e) => {
                        if (!mouseDownOnSlider)
                            return;
                        e.preventDefault();
                        dragging(e);
                    });
                    sliderEl.addEventListener('mouseleave', dragLeave, { passive: true });
                    sliderEl.addEventListener('mouseup', dragStop, { passive: true });
                };
                const dragLeave = (e) => {
                    if (!mouseDownOnSlider)
                        return;
                    mouseDownOnSlider = false;
                    elementsEl.parentElement.style.scrollBehavior = "smooth";
                    // Move the next/previous slider fully into view
                    if (startSliderDragX < currentSliderDragX)
                        previousEvent(e, false, true);
                    else if (startSliderDragX > currentSliderDragX)
                        nextEvent(e, false, true);
                };
                const dragging = (e) => {
                    if (!mouseDownOnSlider || preventSliderDragging)
                        return;
                    elementsEl.parentElement.style.scrollBehavior = 'auto';
                    const posX = getPositionX(e);
                    const posY = getPositionY(e);
                    const deltaX = Math.abs(posX - startSliderDragX);
                    const deltaY = Math.abs(posY - startSliderDragY);
                    sliderPxX += Math.round(posX - currentSliderDragX);
                    if (deltaX >= deltaY) {
                        // We are swiping
                        preventPageScrolling = true;
                    }
                    else {
                        // We are scrolling
                        return;
                    }
                    if (preventPageScrolling)
                        e.preventDefault();
                    if (settings.enableEternalSliding
                        && (settings.eternalSlidingMode || EternalSlidingMode.Infinite) === EternalSlidingMode.Infinite)
                        eXpress.utils.debounce(_ => {
                            if (currentSliderDragX === posX || !mouseDownOnSlider)
                                return; // mouseDownOnSlider == false => already moved by dragStop/dragLeave
                            const element = getFirstVisibleElement();
                            const elementWidth = getFullWidthElement(element, true);
                            const visibleElements = Math.ceil(getFullWidthElement(sliderEl) / elementWidth);
                            const sliderxPassedTiles = -sliderPxX / elementWidth;
                            const direction = currentSliderDragX > posX ? 'left' : 'right';
                            if (direction === 'right' && (sliderxPassedTiles + visibleElements >= settings.sliderElements.length)) {
                                elementsEl.appendChild(elementsEl.children[0]); // add to right
                                sliderPxX += elementWidth;
                                moveSlider(true); // should not move slider
                            }
                            else if (direction === 'left' && (sliderxPassedTiles < 0.2)) {
                                elementsEl.prepend(elementsEl.children[elementsEl.children.length - 1]); // add to left
                                sliderPxX += -elementWidth;
                                moveSlider(true); // should not move slider
                            }
                        }, 250)();
                    // set new location here
                    currentSliderDragX = posX;
                    // move without check => check when stopped
                    moveSlider(true);
                };
                const dragStop = (e) => {
                    mouseDownOnSlider = false;
                    elementsEl.parentElement.style.scrollBehavior = "smooth";
                    const currentSlide = !isDragged ? getSlideFromEventTarget(e.target) : undefined;
                    // enable/disable click event on slider-element when dragging
                    if (!isDragged && !isSliderButtonTarget(e.target))
                        settings.sliderContainerSettings.elementsContainerSettings.slideClicked(e, settings);
                    if (!isDragged && settings.sliderContainerSettings.elementsContainerSettings.onSlideClick && currentSlide) {
                        settings.sliderContainerSettings.elementsContainerSettings.onSlideClick(e, currentSlide);
                    }
                    const slideElements = eXpress.html.querySelectorAll(elementsEl, '.technical-slider-element');
                    const elMethod = isDragged ? 'addEventListener' : 'removeEventListener';
                    slideElements.forEach(el => el[elMethod]('click', preventClick));
                    // Move the next/previous slider fully into view
                    if (startSliderDragX < currentSliderDragX)
                        previousEvent(e, false, true);
                    else if (startSliderDragX > currentSliderDragX)
                        nextEvent(e, false, true);
                    // touch events
                    if (isTouchDevice()) {
                        sliderEl.removeEventListener('touchend', dragStop);
                        sliderEl.removeEventListener('touchmove', dragging);
                        sliderEl.removeEventListener('touchcancel', dragLeave);
                        return;
                    }
                    // remove mouse events
                    sliderEl.removeEventListener('mousemove', dragging);
                    sliderEl.removeEventListener('mouseleave', dragLeave);
                    sliderEl.removeEventListener('mouseup', dragStop);
                    isDragged = false;
                };
                const getPositionX = (e) => {
                    if (!e || !e.type)
                        return 0;
                    if (e.type.includes('mouse')) {
                        const mouseEvent = e;
                        return mouseEvent.pageX;
                    }
                    if (e.type.includes('touch')) {
                        const touchEvent = e;
                        return touchEvent.touches[0].pageX;
                    }
                    return 0;
                };
                const getPositionY = (e) => {
                    if (!e || !e.type)
                        return 0;
                    if (e.type.includes('mouse')) {
                        const mouseEvent = e;
                        return mouseEvent.pageY;
                    }
                    if (e.type.includes('touch')) {
                        const touchEvent = e;
                        return touchEvent.touches[0].pageY;
                    }
                    return 0;
                };
                // #endregion SliderEvents
                const getSliderTemplate = () => {
                    // exclude prev/next buttons
                    settings.sliderElements = settings.sliderElements.filter((el) => el.template && !el.template.classList.contains("technical-slider-button"));
                    if (settings.sliderElements.length === 0)
                        return document.createElement('span');
                    // generate div to hold slider
                    const div = document.createElement('div');
                    div.className += settings.sliderContainerSettings.extraSliderClass;
                    // prev
                    let temp = eXpress.html.querySelector(element, ".technical-slider-prev-button");
                    if (temp)
                        prevButton = temp;
                    prevButton && div.appendChild(prevButton);
                    // images
                    temp = eXpress.html.querySelector(element, ".technical-slider-elements");
                    if (temp)
                        elementsEl = temp;
                    else
                        elementsEl = document.createElement('div');
                    elementsEl.className += settings.sliderContainerSettings.elementsContainerSettings.extraSliderClass;
                    elementsEl.classList.add('technical-slider-elements');
                    for (let i = 0, l = settings.sliderElements.length; i < l; i++) {
                        const customPhotoSliderItem = settings.sliderElements[i];
                        const sliderElementDiv = createSliderElement(customPhotoSliderItem);
                        elementsEl.appendChild(sliderElementDiv);
                    }
                    // append to elementsDiv
                    div.appendChild(elementsEl);
                    // next
                    temp = eXpress.html.querySelector(element, ".technical-slider-next-button");
                    if (temp)
                        nextButton = temp;
                    nextButton && div.appendChild(nextButton);
                    settings.SliderCreated && settings.SliderCreated(settings, div, sliderEl);
                    // return div element
                    return div;
                };
                const getCurrentElement = () => {
                    const elementEl = getFirstVisibleElement();
                    if (!elementEl)
                        return; // if no element visible return
                    const elementElWidth = getFullWidthElement(elementEl, true);
                    const currentElementIndex = elementElWidth <= 0 ? 0 : Math.floor(Math.abs(sliderPxX) / elementElWidth);
                    const index = currentElementIndex % elementsEl.children.length;
                    return settings.sliderElements.find(x => elementsEl.children[index].id === x.id);
                };
                const getAllElements = () => {
                    const slides = Array.from(elementsEl.children);
                    return [...settings.sliderElements].sort((a, b) => {
                        const elementA = slides.find(e => e.id === a.id);
                        const elementB = slides.find(e => e.id === b.id);
                        return slides.indexOf(elementA) - slides.indexOf(elementB);
                    }); //sort a copy of the list
                };
                const resizeSliderElementsToFullWidth = () => {
                    const element = getFirstVisibleElement();
                    if (!element || !element.parentElement || element.clientWidth <= 0)
                        return;
                    const widthAfterResize = getFullWidthElement(element.parentElement);
                    if (widthBeforeResize === widthAfterResize)
                        return;
                    for (let i = 0; i < elementsEl.children.length; i++) {
                        const slide = elementsEl.children[i];
                        slide.style.width = `${widthAfterResize}px`;
                        slide.style.minWidth = `${widthAfterResize}px`;
                        slide.style.maxWidth = `${widthAfterResize}px`;
                    }
                    // Realign the slider with the first visible element
                    // sliderPxX = the amount the sldier was moved to the left, usually a multiple of widthBeforeResize
                    // We need to realign it, so we divide sliderPxX by the widthBeforeResize, so we know how many slides we need to move it
                    if (widthBeforeResize > 0) {
                        const amountOfSlides = Math.abs(Math.ceil(sliderPxX / widthBeforeResize));
                        sliderPxX = sliderPxX - ((widthAfterResize - widthBeforeResize) * amountOfSlides);
                    }
                    widthBeforeResize = widthAfterResize;
                };
                const checkEdgesAndMove = (movePx, draggedSlider, jumpIntoView = false) => {
                    // if beginning or end stop
                    sliderPxX += movePx;
                    let prevButtonClasslistMethod = 'add';
                    let nextButtonClasslistMethod = 'add';
                    const element = getFirstVisibleElement();
                    const elementWidth = getFullWidthElement(element, true);
                    let moveToOtherside = false;
                    // we calculate the total width of the elements because of the gap property on the slider
                    // without gap => every slider the same width => is the same as elementsEl.scrollWidth
                    // with gap => we come 1 gap to short at the end to have the same width
                    const endOfSlider = () => getFullWidthElement(sliderEl) - (elementWidth * settings.sliderElements.length);
                    const widthRightSidePx = () => (elementWidth * settings.sliderElements.length) - Math.abs(sliderPxX);
                    if (sliderPxX >= 0) { // test negative scroll
                        nextButtonClasslistMethod = 'remove';
                        if (settings.enableEternalSliding)
                            prevButtonClasslistMethod = 'remove';
                        if (settings.enableEternalSliding && !jumpIntoView && sliderPxX > 0) {
                            switch (settings.eternalSlidingMode) {
                                case EternalSlidingMode.ScrollToBegin:
                                    moveToOtherside = true;
                                    sliderPxX = endOfSlider();
                                    break;
                                case EternalSlidingMode.Infinite:
                                default:
                                    elementsEl.prepend(elementsEl.children[elementsEl.children.length - 1]);
                                    moveSlider(true, false, -sliderPxX); // update HTML with current pxX after move => should not move visually
                                    sliderPxX = 0;
                                    break;
                            }
                        }
                        else
                            sliderPxX = 0;
                    }
                    else if (widthRightSidePx() <= getFullWidthElement(sliderEl)) { // test positive scroll
                        prevButtonClasslistMethod = 'remove';
                        if (settings.enableEternalSliding)
                            nextButtonClasslistMethod = 'remove';
                        if (settings.enableEternalSliding && !jumpIntoView && widthRightSidePx() < getFullWidthElement(sliderEl)) {
                            switch (settings.eternalSlidingMode) {
                                case EternalSlidingMode.ScrollToBegin:
                                    moveToOtherside = true;
                                    sliderPxX = 0;
                                    break;
                                case EternalSlidingMode.Infinite:
                                default:
                                    if (elementWidth <= 0)
                                        break; // if you element is not visible don't do anything
                                    do {
                                        elementsEl.appendChild(elementsEl.children[0]);
                                        moveSlider(true, false, sliderPxX + Math.abs(movePx) + elementWidth); // update HTML with current pxX after move => should not move visually
                                        sliderPxX += elementWidth;
                                    } while (widthRightSidePx() < getFullWidthElement(sliderEl));
                                    break;
                            }
                        }
                        else
                            sliderPxX = endOfSlider();
                    }
                    else { // the scroll is not over positive or over negative
                        prevButtonClasslistMethod = 'remove';
                        nextButtonClasslistMethod = 'remove';
                    }
                    // check if images div is greater then px width
                    if (getFullWidthElement(sliderEl) >= (getFullWidthElement(element, true) * settings.sliderElements.length)) {
                        nextButtonClasslistMethod = 'add';
                        prevButtonClasslistMethod = 'add';
                    }
                    if (!jumpIntoView) {
                        if (settings.sliderContainerSettings.cssWhenButtonsBothOnMax) {
                            if (prevButton)
                                prevButton.classList.toggle(settings.sliderContainerSettings.cssWhenButtonsBothOnMax, nextButtonClasslistMethod === 'add' && prevButtonClasslistMethod === 'add');
                            if (nextButton)
                                nextButton.classList.toggle(settings.sliderContainerSettings.cssWhenButtonsBothOnMax, nextButtonClasslistMethod === 'add' && prevButtonClasslistMethod === 'add');
                        }
                        // add or remove class from classlist depending on ifs
                        if (prevButton)
                            prevButton.classList[prevButtonClasslistMethod](settings.sliderContainerSettings.previousButton.cssWhenOnMax);
                        if (nextButton)
                            nextButton.classList[nextButtonClasslistMethod](settings.sliderContainerSettings.nextButton.cssWhenOnMax);
                    }
                    if (prevButton || nextButton)
                        moveSlider(draggedSlider, moveToOtherside);
                };
                const moveSlider = (draggedSlider, moveToOtherside = false, sliderPxXOverride) => {
                    const ms = moveToOtherside ? elementsEl.children.length * 250 : 200;
                    elementsEl.style.transition = draggedSlider ? 'none' : `all ${ms}ms ease-in-out 0s`;
                    const pixelX = sliderPxXOverride || sliderPxXOverride >= 0 ? sliderPxXOverride : sliderPxX;
                    if (settings.translateForMovement) {
                        elementsEl.style.transform = `translateX(${pixelX}px)`;
                    }
                    else {
                        elementsEl.parentElement && elementsEl.parentElement.scroll({
                            top: 0,
                            left: -pixelX,
                            // @ts-ignore https://developer.mozilla.org/en-US/docs/Web/API/Window/scroll => instant is a behavior that is supported
                            behavior: draggedSlider ? 'instant' : 'smooth'
                        });
                    }
                };
                const createSliderElement = (customPhotoSliderItem) => {
                    if (!customPhotoSliderItem.id)
                        customPhotoSliderItem.id = eXpress.utils.newSliderGuid();
                    // elements
                    const sliderElement = customPhotoSliderItem.template ? customPhotoSliderItem.template.cloneNode(true) : document.createElement('div');
                    sliderElement.id = customPhotoSliderItem.id;
                    sliderElement.classList.add('technical-slider-element');
                    //return div
                    return sliderElement;
                };
                const removeImageFromArray = (indexToRemove) => {
                    if (!settings.sliderElements || indexToRemove > settings.sliderElements.length - 1 || indexToRemove < 0 || !settings.sliderElements[indexToRemove])
                        throw Error('Something is wrong with your current parameters');
                    else {
                        let tempArray = settings.sliderElements.slice(0, indexToRemove);
                        // if last item remove this is faster
                        if (tempArray.length === settings.sliderElements.length - 1) {
                            settings.sliderElements = tempArray;
                            return;
                        }
                        tempArray = tempArray.concat(settings.sliderElements.slice(indexToRemove + 1));
                        settings.sliderElements = tempArray;
                    }
                };
                const insertIntoSliderElements = (sliderElement, indexToInsert) => {
                    // if images.length => just push
                    if (indexToInsert === settings.sliderElements.length) {
                        settings.sliderElements.push(sliderElement);
                        return;
                    }
                    // if 0 add to new array copy old array into new array => change array
                    if (indexToInsert === 0) {
                        const tempArray = [sliderElement];
                        settings.sliderElements = tempArray.concat(settings.sliderElements);
                        return;
                    }
                    // insert in between
                    let tempArray = settings.sliderElements.slice(0, indexToInsert);
                    tempArray.push(sliderElement);
                    tempArray = tempArray.concat(settings.sliderElements.slice(indexToInsert));
                    settings.sliderElements = tempArray;
                };
                const calculateNextMove = function (positiveMove) {
                    const elementEl = getFirstVisibleElement();
                    // if no slider just skip
                    if (settings.sliderElements.length <= 1 || !elementEl)
                        return 0;
                    // !!! WARNING !!! solution for all same width elements !!!
                    const elementElWidth = getFullWidthElement(elementEl, true);
                    if (Math.ceil(getFullWidthElement(elementsEl)) / elementElWidth < 1)
                        return elementElWidth * (positiveMove ? -0.5 : 0.5); // default 0.50 % of slide move
                    // calculate sliderElement.width / width elements => get % of visible slide on each side
                    const pxRight = (elementElWidth * settings.sliderElements.length) - (Math.ceil(getFullWidthElement(sliderEl)) + Math.abs(sliderPxX));
                    const maxPossibleSliderItemsRightPx = pxRight / elementElWidth;
                    const maxPossibleSliderItemsLeftpx = Math.abs(sliderPxX) / elementElWidth;
                    let percentage = positiveMove
                        ? (settings.eternalSlidingMode || EternalSlidingMode.Infinite) == EternalSlidingMode.Infinite ? (maxPossibleSliderItemsLeftpx - Math.floor(maxPossibleSliderItemsLeftpx)) - 1 : -(maxPossibleSliderItemsRightPx - Math.floor(maxPossibleSliderItemsRightPx))
                        : maxPossibleSliderItemsLeftpx - Math.floor(maxPossibleSliderItemsLeftpx);
                    // Floating point arithmetic is not always 100% accurate
                    percentage = parseInt(`${percentage * 10000}`) / 10000;
                    // for the case that the slide is exactly on the page
                    // or slider the slide is already almost fully visitable and you want to go to the next slide
                    if (percentage === 0 || Math.abs(percentage) <= 0.08)
                        percentage += positiveMove ? -1 : 1;
                    // if half slides have to be shown
                    if (settings.showHalfSlides)
                        percentage *= 1.5;
                    // calculate how much % the slide needs to be completely shown
                    return elementElWidth * percentage;
                };
                const jumpIntoView = (sliderElement, smoothSlideIntoView = true, align = 'start') => {
                    const elements = getAllElements();
                    let indexOfElement = elements.indexOf(sliderElement);
                    if (indexOfElement < 0)
                        return;
                    const visibleEl = getFirstVisibleElement(); // this slide is already visible => no width of 0
                    const element = eXpress.html.querySelector(elementsEl, `#${visibleEl.id}`, true);
                    const elementWidth = getFullWidthElement(element, true);
                    let moveToLocation;
                    switch (settings.eternalSlidingMode) {
                        case EternalSlidingMode.ScrollToBegin:
                            moveToLocation = (elementWidth * indexOfElement) - (align == 'start' ? 0 : (elementWidth * ((getFullWidthElement(sliderEl) / elementWidth) - 1))); // -1 because this is a count, not an index
                            break;
                        case EternalSlidingMode.Infinite:
                        default: {
                            const currentSlide = getCurrentElement();
                            const currentSlideIndex = elements.indexOf(currentSlide);
                            const visibleElements = Math.ceil(getFullWidthElement(sliderEl) / elementWidth);
                            switch (align) {
                                case 'start':
                                    {
                                        if (currentSlideIndex > indexOfElement)
                                            break;
                                        const elementsToMoveToFront = [...elements].splice(currentSlideIndex + visibleElements);
                                        elementsToMoveToFront.forEach((_, i) => {
                                            elementsEl.prepend(elementsEl.children[elementsEl.children.length - 1]);
                                            sliderPxX -= elementWidth;
                                            moveSlider(true, false); // update HTML with current pxX after move => should not move visually
                                        });
                                        break;
                                    }
                                case 'end':
                                default:
                                    {
                                        if (currentSlideIndex < indexOfElement)
                                            break;
                                        const elementsToMoveToBack = [...elements].splice(currentSlideIndex);
                                        elementsToMoveToBack.forEach((_, i) => {
                                            elementsEl.appendChild(elementsEl.children[0]);
                                            sliderPxX += elementWidth;
                                            moveSlider(true, false); // update HTML with current pxX after move => should not move visually
                                        });
                                        break;
                                    }
                            }
                            indexOfElement = getAllElements().indexOf(sliderElement); // recalculate index after move
                            moveToLocation = (elementWidth * indexOfElement) - (align == 'start' ? 0 : (elementWidth * ((getFullWidthElement(sliderEl) / elementWidth) - 1))); // -1 because this is a count, not an index
                            break;
                        }
                    }
                    // update item
                    const movePx = moveToLocation > Math.abs(sliderPxX) ? -moveToLocation - sliderPxX : Math.abs(sliderPxX) - moveToLocation;
                    checkEdgesAndMove(movePx, !smoothSlideIntoView, true);
                };
                const getFirstVisibleElement = () => {
                    if (!elementsEl)
                        return;
                    if (firstVisibleElement)
                        return firstVisibleElement;
                    for (let i = 0; i < elementsEl.children.length; i++) {
                        const element = elementsEl.children[i];
                        if (element && element.id) {
                            const htmlElement = eXpress.html.querySelector(elementsEl, `#${element.id}`, true);
                            if (getFullWidthElement(htmlElement) > 0 && htmlElement.clientWidth > 0) {
                                firstVisibleElement = htmlElement;
                                return htmlElement;
                            }
                        }
                    }
                    // return default
                    return undefined;
                };
                const getFullWidthElement = (element, isSliderElement = false) => {
                    if (!element)
                        return 0;
                    const style = window.getComputedStyle(element), width = style.width ? parseFloat(style.width) ? parseFloat(style.width) : element.clientWidth : element.clientWidth, // style.width already had the border in the calculation
                    margin = parseFloat(style.marginLeft ? style.marginLeft : '0') + parseFloat(style.marginRight ? style.marginRight : '0'), padding = parseFloat(style.paddingLeft ? style.paddingLeft : '0') + parseFloat(style.paddingRight ? style.paddingRight : '0');
                    return Math.ceil((width + (margin ? margin : 0) + (padding ? padding : 0)) + (isSliderElement ? parseFloat(window.getComputedStyle(elementsEl).gap || '0') || 0 : 0)); // Math.ceil to get a rounded number => Firefox, Edge don't work with decimals
                };
                // public methods
                const removeSliderElement = (sliderElement, indexToRemove) => {
                    // check params
                    if ((!indexToRemove && settings.sliderElements.filter(x => x.id === sliderElement).length < 0) || (indexToRemove && (indexToRemove < 0 || indexToRemove > settings.sliderElements.length - 1)))
                        throw Error('Index to remove not found');
                    // remove image
                    removeImageFromArray(indexToRemove ? indexToRemove : settings.sliderElements.indexOf(sliderElement));
                    // reset firstVisibleElement
                    firstVisibleElement = undefined;
                    // Manipulate dom
                    if (!sliderElement.id)
                        throw Error('invalid image id');
                    // search image el to delete
                    const deleteImageEl = eXpress.html.querySelector(elementsEl, `#${sliderElement.id}`, true);
                    elementsEl.removeChild(deleteImageEl);
                    // check edges over invalid sliderPxX
                    checkEdgesAndMove(0);
                };
                const removeSliderElementOnIndex = (indexToRemove) => {
                    // check params
                    if ((indexToRemove < 0 || indexToRemove > settings.sliderElements.length - 1))
                        throw Error('Index to remove not found');
                    // remove image
                    const deletedElement = settings.sliderElements[indexToRemove];
                    removeSliderElement(deletedElement, indexToRemove);
                };
                const addSliderElement = (sliderElement, indexToInsert = settings.sliderElements.length) => {
                    // id check for UI
                    // if id already found generate new one => no bugs in dots this way
                    if (!sliderElement.id || settings.sliderElements.find(x => x.id === sliderElement.id))
                        sliderElement.id = eXpress.utils.newSliderGuid();
                    // insert element in slider on index
                    const element = indexToInsert === settings.sliderElements.length
                        ? settings.sliderElements[settings.sliderElements.length - 1]
                        : settings.sliderElements[indexToInsert];
                    insertIntoSliderElements(sliderElement, indexToInsert);
                    const prevElement = eXpress.html.querySelector(elementsEl, `#${element.id}`, true);
                    const newSlideElement = createSliderElement(sliderElement);
                    indexToInsert === settings.sliderElements.length
                        ? elementsEl.insertAdjacentElement("afterend", newSlideElement)
                        : elementsEl.insertBefore(newSlideElement, prevElement);
                    jumpIntoView(sliderElement);
                };
                const reset = () => {
                    if (settings.resize1SlideToFullWidth)
                        resizeSliderElementsToFullWidth();
                    settings.BeforeResizeEvent && settings.BeforeResizeEvent(settings, sliderEl);
                    checkEdgesAndMove(0);
                    settings.ResizeEvent && settings.ResizeEvent(settings, sliderEl);
                };
                const previousEvent = (e, draggedSlider = false, draggedSliderEventTracking = false) => {
                    if (!settings.enableEternalSliding)
                        checkEdgesAndMove(0);
                    if (prevButton && prevButton.classList.contains(settings.sliderContainerSettings.previousButton.cssWhenOnMax))
                        return;
                    // calculate next move
                    const nextMove = calculateNextMove(false);
                    // update item
                    checkEdgesAndMove(nextMove, draggedSlider);
                    // on click event of settings
                    settings.sliderContainerSettings.previousButton.onClick(e, draggedSliderEventTracking);
                };
                const nextEvent = (e, draggedSlider = false, draggedSliderEventTracking = false) => {
                    if (!settings.enableEternalSliding)
                        checkEdgesAndMove(0);
                    if (nextButton && nextButton.classList.contains(settings.sliderContainerSettings.nextButton.cssWhenOnMax))
                        return;
                    // calculate next move
                    const nextMove = calculateNextMove(true);
                    // update item
                    checkEdgesAndMove(nextMove, draggedSlider);
                    // on click event of settings
                    settings.sliderContainerSettings.nextButton.onClick(e, draggedSliderEventTracking);
                };
                const createIntersectionObserver = () => {
                    if (('InterSectionObserver' in window || 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
                        return new IntersectionObserver((entries, observer) => {
                            entries.forEach(entry => {
                                if (entry.isIntersecting && entry.target.classList.contains(element.classList[0])) {
                                    ioSlider = undefined;
                                    // init slider when in parent element in view
                                    init(element, settings.replaceWithElement);
                                    observer.unobserve(entry.target);
                                }
                            });
                        }, { rootMargin: "0px 0px 0px 0px" });
                    }
                };
                const showButtons = () => {
                    nextButton && eXpress.html.removeClass(nextButton, settings.sliderContainerSettings.cssWhenButtonsBothOnMax);
                    prevButton && eXpress.html.removeClass(prevButton, settings.sliderContainerSettings.cssWhenButtonsBothOnMax);
                };
                const hideButtons = () => {
                    nextButton && eXpress.html.addClass(nextButton, settings.sliderContainerSettings.cssWhenButtonsBothOnMax);
                    prevButton && eXpress.html.addClass(prevButton, settings.sliderContainerSettings.cssWhenButtonsBothOnMax);
                };
                let ioSlider = createIntersectionObserver();
                // init slider
                init(element, settings.replaceWithElement);
                // return
                return {
                    RemoveSliderElement: removeSliderElement,
                    RemoveSliderElementOnIndex: removeSliderElementOnIndex,
                    AddSliderElement: addSliderElement,
                    Previous: previousEvent,
                    Next: nextEvent,
                    JumpIntoView: jumpIntoView,
                    Settings: settings,
                    GetCurrentSlide: getCurrentElement,
                    GetAllSlides: getAllElements,
                    GetSliderElement: () => sliderEl,
                    ShowButtons: showButtons,
                    HideButtons: hideButtons,
                    Dispose: dispose,
                    AddHandlers: addHandlers
                };
            }
            main.createCustomSlider = createCustomSlider;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            let ExternalLoginProvider;
            (function (ExternalLoginProvider) {
                ExternalLoginProvider[ExternalLoginProvider["Google"] = 0] = "Google";
                ExternalLoginProvider[ExternalLoginProvider["Facebook"] = 1] = "Facebook";
            })(ExternalLoginProvider || (ExternalLoginProvider = {}));
            const signInButtons = [];
            const enableButton = (button) => {
                button.enable();
                const item = signInButtons.filter((b) => b.Button == button)[0];
                item && item.ButtonEl.classList.remove('skeleton-loading');
            };
            function createGoogleLogin(googleLoginButtonEl, onOrderFlow, deps) {
                const { handleExternalLoginResult } = deps;
                const googleButton = components.main.createButton(googleLoginButtonEl);
                signInButtons.push({ Provider: ExternalLoginProvider.Google, ButtonEl: googleLoginButtonEl, Button: googleButton });
                const initClient = () => {
                    if (typeof (google) === "undefined") {
                        setTimeout(initClient, 50);
                        return;
                    }
                    const clientId = googleLoginButtonEl.dataset.appid || '';
                    const scope = googleLoginButtonEl.dataset.scope;
                    // authenticate - login
                    google.accounts.id.initialize({
                        client_id: clientId,
                        use_fedcm_for_button: true, // use_fedcm_for_button is missing in the definition-file but is required for fedcm to work
                        callback: (response) => __awaiter(this, void 0, void 0, function* () {
                            const body = {
                                jwtToken: response.credential,
                                onOrderFlow: onOrderFlow,
                                scope: scope
                            };
                            $.ajax({
                                url: '/ajaxxhr/Login/LoginWithGoogle',
                                type: 'POST',
                                global: false,
                                contentType: 'application/json; charset=utf-8',
                                data: JSON.stringify(body),
                                dataType: 'json'
                            }).then((res) => {
                                handleExternalLoginResult(res, "googlephotos", false, onOrderFlow, response.credential, scope);
                            });
                        }),
                    });
                    google.accounts.id.renderButton(googleLoginButtonEl, {
                        type: 'standard',
                        shape: "rectangular",
                        size: 'large',
                        width: 250,
                        locale: window.context.locale,
                    });
                    enableButton(googleButton);
                };
                // Add the script only once
                const googleScriptSrc = 'https://accounts.google.com/gsi/client?hl=' + window.context.language;
                const scripts = document.getElementsByTagName('script');
                for (const item of scripts) {
                    if (item.src === googleScriptSrc) {
                        // Script-tag already exists. Manually call init-func
                        initClient();
                        return;
                    }
                }
                // load google script async
                const scriptEl = document.createElement('script');
                scriptEl.type = 'text/javascript';
                scriptEl.async = true;
                scriptEl.defer = true;
                scriptEl.onload = initClient;
                scriptEl.src = googleScriptSrc;
                const firstScriptEl = document.getElementsByTagName('script')[0];
                firstScriptEl.parentElement.insertBefore(scriptEl, firstScriptEl);
            }
            main.createGoogleLogin = createGoogleLogin;
            function createFacebookLoginButton(facebookButtonEl, onOrderFlow, deps) {
                const { handleExternalLoginResult } = deps;
                let disposableEvent;
                let isFacebookInitialized = false;
                const facebookButton = components.main.createButton(facebookButtonEl);
                signInButtons.push({ Provider: ExternalLoginProvider.Facebook, ButtonEl: facebookButtonEl, Button: facebookButton });
                const onClick = (ev) => {
                    var _a;
                    if (ev.preventDefault) {
                        ev.preventDefault();
                    }
                    ev.stopPropagation();
                    facebookButton.disable();
                    const scopes = (_a = facebookButtonEl.dataset.scope) !== null && _a !== void 0 ? _a : '';
                    loginToFacebook(scopes, false, onOrderFlow);
                };
                const init = () => {
                    if (typeof (FB) === "undefined")
                        return;
                    if (!isFacebookInitialized) {
                        const appId = facebookButtonEl.dataset.appid ? facebookButtonEl.dataset.appid : '';
                        initFacebook(appId);
                    }
                    disposableEvent = eXpress.html.addEventListener(facebookButtonEl, 'click', onClick);
                    enableButton(facebookButton);
                };
                const initFacebook = (appId) => {
                    FB.init({ appId: appId, status: false, cookie: true, version: 'v22.0' }); //status: false check the login status upon init -> we will do this with getLoginStatus
                    isFacebookInitialized = true;
                    eXpress.html.show(facebookButtonEl);
                };
                const loginToFacebook = (requestedScopes, skipLogin, onOrderFlow) => {
                    if (typeof (FB) === "undefined")
                        return;
                    if (skipLogin === null)
                        skipLogin = false;
                    FB.login(function (loginResponse) {
                        if (!loginResponse ||
                            loginResponse.status !== "connected" ||
                            !loginResponse.authResponse ||
                            !loginResponse.authResponse.userID)
                            return enableButton(facebookButton);
                        const uid = loginResponse.authResponse.userID;
                        // check if all permissions are granted (result is also 'connected' when permissions are partialy granted)
                        FB.api("/" + uid + "/permissions", (response) => __awaiter(this, void 0, void 0, function* () {
                            if (!response || !response.data || response.data.length == 0)
                                return enableButton(facebookButton);
                            if (!checkFacebookPermissions(requestedScopes, response.data))
                                return enableButton(facebookButton);
                            // user granted all permissions
                            const accessToken = loginResponse.authResponse.accessToken;
                            const scopes = response.data.map((scope) => (scope.status == "granted" ? scope.permission : ""));
                            const expiresIn = loginResponse.authResponse.expiresIn;
                            const body = {
                                userId: uid,
                                accessToken: accessToken,
                                expiresIn: expiresIn,
                                scopes: scopes,
                                onOrderFlow: onOrderFlow,
                            };
                            $.ajax({
                                url: '/ajaxxhr/Login/LoginWithFacebook',
                                type: 'POST',
                                global: false,
                                contentType: 'application/json; charset=utf-8',
                                data: JSON.stringify(body),
                                dataType: 'json'
                            }).then((res) => {
                                handleExternalLoginResult(res, "facebook", false, onOrderFlow, uid, accessToken, scopes.join(" "), expiresIn);
                            }).always(() => { enableButton(facebookButton); });
                        }));
                    }, { scope: requestedScopes, auth_type: "rerequest" });
                };
                const checkFacebookPermissions = (requestedScopes, data) => {
                    if (!data)
                        return false;
                    if (!requestedScopes)
                        return false;
                    const requestedScopesArr = requestedScopes.split(" ");
                    const grantedScopes = data.filter((e) => e.status === "granted").map((e) => e.permission);
                    const allowedScopes = grantedScopes.filter((grantedScope) => requestedScopesArr.includes(grantedScope));
                    return allowedScopes.length == requestedScopesArr.length;
                };
                const deInit = () => disposableEvent && disposableEvent.dispose();
                init();
                return {
                    dispose: deInit,
                };
            }
            main.createFacebookLoginButton = createFacebookLoginButton;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createForgotPassword(containerEl, deps) {
                const { confirmForgotPasswordAsync } = deps;
                const formEl = eXpress.html.querySelector(containerEl, ".technical-forgot-password-form", true);
                const forgotPasswordForm = components.main.initForm(formEl, {
                    onSubmitForm: (formData) => confirmForgotPasswordAsync(formData["email"]),
                    submitOnEnter: true
                });
                return {
                    dispose: () => {
                        forgotPasswordForm.dispose();
                    }
                };
            }
            main.createForgotPassword = createForgotPassword;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createBaseFormInput(containerEl, altSelector) {
                const inputEl = eXpress.html.querySelector(containerEl, altSelector || ".a-form-input__input", true);
                const errorParagraphEl = eXpress.html.querySelector(containerEl, '.a-form-input__error-text');
                const toggleAttribute = (attr, force) => inputEl.toggleAttribute(attr, force);
                const toggleEnable = (enable) => {
                    toggleAttribute('disabled', !enable);
                    eXpress.html.toggleClass(containerEl, 'a-form-input--disabled', !enable);
                };
                const clear = (clearValue = false) => {
                    clearValue && (inputEl.value = '');
                    containerEl.classList.remove("a-form-input--validated");
                    containerEl.classList.remove("a-form-input--error");
                };
                const setError = (error, doClear = false) => {
                    doClear && clear();
                    containerEl.classList.remove("a-form-input--validated");
                    containerEl.classList.add("a-form-input--error");
                    errorParagraphEl && (errorParagraphEl.innerHTML = error);
                };
                const setRequired = (value) => {
                    inputEl.required = value;
                };
                return {
                    clear,
                    setError,
                    enable: () => toggleEnable(true),
                    disable: () => toggleEnable(false),
                    inputEl,
                    show: () => containerEl.classList.remove('u-hide'),
                    hide: () => containerEl.classList.add('u-hide'),
                    isRequired: inputEl.required,
                    setRequired
                };
            }
            main.createBaseFormInput = createBaseFormInput;
            function createCheckBox(containerEl, onChange, altSelector) {
                const input = createFormInput(containerEl, altSelector);
                let event;
                onChange && (event = eXpress.html.addEventListener(input.inputEl, "change", () => onChange(!!input.getValue())));
                return Object.assign(Object.assign({}, input), { dispose: () => event && event.dispose });
            }
            main.createCheckBox = createCheckBox;
            function createSelectBox(containerEl, onSelected) {
                const baseComponent = createBaseFormInput(containerEl);
                const selectEl = baseComponent.inputEl;
                const setValue = (value) => (selectEl.value = value);
                const onSelect = () => onSelected && onSelected(selectEl.value);
                const disposableEvent = eXpress.html.addEventListener(selectEl, 'change', onSelect);
                return Object.assign(Object.assign({}, baseComponent), { dispose: disposableEvent.dispose, inputEl: selectEl, setValue, getValue: () => selectEl.value });
            }
            main.createSelectBox = createSelectBox;
            function createHiddenFormInput(el) {
                const inputEl = el;
                const getValue = () => inputEl.value;
                const setValue = (value) => {
                    el.value = value;
                };
                const clear = (clearValue) => {
                    clearValue && (inputEl.value = '');
                };
                const setError = (error, doClear) => {
                    if (doClear) {
                        clear();
                    }
                };
                const hide = () => {
                    return;
                };
                const show = () => {
                    return;
                };
                const setRequired = (value) => {
                    return;
                };
                const enable = () => {
                    return;
                };
                const disable = () => {
                    return;
                };
                return {
                    inputEl,
                    setValue,
                    getValue,
                    clear,
                    setError,
                    hide,
                    show,
                    setRequired,
                    enable,
                    disable
                };
            }
            main.createHiddenFormInput = createHiddenFormInput;
            function createFormInput(containerEl, altSelector) {
                const baseComponent = createBaseFormInput(containerEl, altSelector);
                const inputEl = baseComponent.inputEl;
                const isCheckBox = inputEl.type.toLowerCase() === 'checkbox';
                const setValue = (value) => isCheckBox
                    ? inputEl.checked = value.toString().toLowerCase() === "true"
                    : (inputEl.value = value.toString());
                // format input
                inputEl.addEventListener('focusout', () => {
                    const formatExample = inputEl.getAttribute('format-example');
                    const regex = inputEl.getAttribute('regex');
                    // formatimage not there, regex already matches, regex does not match formatexample => do nothing
                    if (!formatExample || !inputEl.value || (regex && new RegExp(regex).test(inputEl.value)) || (formatExample && regex && !new RegExp(regex).test(formatExample)))
                        return;
                    inputEl.value = inputEl.value.trim();
                    let spaceIndex = formatExample.indexOf(' ');
                    while (spaceIndex >= 0 && spaceIndex <= inputEl.value.length - 1) {
                        // add only if not added yet
                        if (inputEl.value[spaceIndex] !== ' ')
                            inputEl.value = inputEl.value.slice(0, spaceIndex) + ' ' + inputEl.value.slice(spaceIndex);
                        spaceIndex = formatExample.indexOf(' ', spaceIndex + 1);
                    }
                });
                const getValue = () => isCheckBox
                    ? inputEl.checked
                    : inputEl.value;
                if (inputEl.type.toLowerCase() === 'text' && inputEl.inputMode.toLowerCase() == 'tel' && inputEl.getAttribute('countrycode')) {
                    const countryCode = inputEl.getAttribute('countrycode');
                    const togglePhoneNumberPrefix = (element, inFocus) => {
                        if (!inFocus)
                            element.value = element.value.replace(/\s/g, ''); // replace all whitespace with empty string
                        if (element.value === eXpress.utils.FillPhoneWithCountryPrefixWhenEmpty(countryCode) || !element.value)
                            element.value = inFocus ? eXpress.utils.FillPhoneWithCountryPrefixWhenEmpty(countryCode) : '';
                    };
                    inputEl.addEventListener('focusout', () => togglePhoneNumberPrefix(inputEl, false));
                    inputEl.addEventListener('focusin', () => togglePhoneNumberPrefix(inputEl, true));
                }
                return Object.assign(Object.assign({ setValue,
                    getValue }, baseComponent), { inputEl });
            }
            main.createFormInput = createFormInput;
            function createPasswordFormInput(containerEl) {
                const formInput = createFormInput(containerEl);
                const iconEl = eXpress.html.querySelector(containerEl, ".technical-password-unhide-icon", false);
                let disposableEvent;
                const validatePassword = () => {
                    const value = formInput.inputEl.value;
                    formInput.inputEl.dataset["lastvalidatedpassword"] = '';
                    formInput.inputEl.dataset["lastvalidatedresult"] = '';
                    return !formInput.isRequired || !value || value.length < Number.parseInt(formInput.inputEl.dataset.minlength || "6", 10)
                        ? $.Deferred().resolve(true).promise() // this is done by another check in the form
                        : formInput.inputEl.hasAttribute("data-pristine-strongpassword") &&
                            formInput.inputEl.dataset.pristineStrongpassword === "true"
                            ? $.ajax({
                                url: "/ajaxxhr/Login/ValidatePassword",
                                method: 'POST',
                                data: {
                                    password: eXpress.utils.stringToBase64(formInput.inputEl.value),
                                }
                            }).then((res) => {
                                formInput.inputEl.dataset["lastvalidatedpassword"] = value;
                                formInput.inputEl.dataset["lastvalidatedresult"] = `${res.isValid}`;
                                !res.isValid && formInput.setError(res.Label);
                                return res.isValid;
                            })
                            : $.Deferred().resolve(true).promise();
                };
                const onPasswordShowHideIconClick = () => {
                    switch (formInput.inputEl.getAttribute("type")) {
                        case "password":
                            formInput.inputEl.setAttribute("type", "text");
                            if (iconEl)
                                iconEl.classList.add("a-form-input__password-unhide-icon--hide");
                            break;
                        case "text":
                            formInput.inputEl.setAttribute("type", "password");
                            if (iconEl)
                                iconEl.classList.remove("a-form-input__password-unhide-icon--hide");
                            break;
                        default:
                            break;
                    }
                };
                const disable = () => {
                    formInput.disable();
                    if (iconEl) {
                        iconEl.style.cursor = 'not-allowed';
                        dispose();
                    }
                };
                const enable = () => {
                    formInput.enable();
                    if (iconEl) {
                        iconEl.style.cursor = 'pointer';
                        addEvent();
                    }
                };
                const dispose = () => { if (disposableEvent)
                    disposableEvent.dispose(); };
                const addEvent = () => (disposableEvent = iconEl ? eXpress.html.addEventListener(iconEl, 'click', onPasswordShowHideIconClick) : null);
                if (iconEl)
                    addEvent();
                return Object.assign(Object.assign({ validatePassword }, formInput), { disable,
                    enable });
            }
            main.createPasswordFormInput = createPasswordFormInput;
            function createTextInputWithAutoComplete(inputEl, deps) {
                inputEl.setAttribute('autocomplete', 'off');
                // defaults are for choice of delivery
                const { autoCompleteSearch, onSelect, customize, onOpen, onClose, renderTextContent, debounceWaitMs = 250, containerInsertPosition = 'beforeend', containerClass = 'm-autocomplete a-form-input__autocomplete', disableAutoSelect = true, preventSubmit = false, minLength = 3 } = deps;
                const autocompleteResult = autocomplete.autocomplete({
                    minLength,
                    input: inputEl,
                    disableAutoSelect,
                    preventSubmit,
                    onSelect: (item, input) => {
                        input.value = item.label || item.value;
                        onSelect && onSelect({ value: item.value, label: item.label });
                    },
                    fetch: (text, update) => {
                        text = text.toLowerCase();
                        autoCompleteSearch(text)
                            .then(res => update(res));
                    },
                    render: (item, currentValue) => {
                        const itemEl = document.createElement("div");
                        eXpress.html.addClass(itemEl, 'm-suggestion-list__item technical-search-suggestion');
                        itemEl.innerHTML = renderTextContent && renderTextContent(item, currentValue) || `${item.label} - ${item.value}`;
                        return itemEl;
                    },
                    customize: (input, inputRect, container, maxHeight) => {
                        customize && customize(input, inputRect, container, maxHeight);
                        eXpress.html.removeClass(container, 'autocomplete');
                        eXpress.html.addClass(container, containerClass);
                        container.removeAttribute('style');
                        container.style.display = "block";
                        const inputContainerEl = input.parentElement;
                        inputContainerEl.insertAdjacentElement(containerInsertPosition, container);
                        onOpen && onOpen();
                    },
                    debounceWaitMs
                });
                const disposable = onClose
                    ? eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(inputEl, 'input', _ => {
                            if (inputEl.value && inputEl.value.length < minLength)
                                onClose();
                        }),
                        eXpress.html.addEventListener(inputEl, 'focusout', _ => { onClose(); }),
                    ])
                    : null;
                return {
                    dispose: () => { disposable && disposable.dispose(); autocompleteResult.destroy(); },
                };
            }
            main.createTextInputWithAutoComplete = createTextInputWithAutoComplete;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            // general form component
            // http://brandplatform.smartphoto.com/general/molecules/form/
            function initForm(formEl, deps) {
                const { alternativeButton, onSubmitForm, buttonSelector, submitOnEnter, validatorOptions, onDirtyNavigateAway } = deps;
                const onSubmit = () => {
                    return validate().then(x => {
                        if (!x)
                            return;
                        isDirty = false;
                        return onSubmitForm(formData());
                    });
                };
                const submitButtonEl = alternativeButton || eXpress.html.querySelector(formEl, buttonSelector || '.m-form__button-continue', true);
                const submitButton = main.createButton(submitButtonEl, onSubmit);
                const validator = createFormValidator(formEl, validatorOptions);
                createFormAddressSuggestor(formEl);
                let onKeyUpEvent;
                let isDirty = false;
                const formElements = Array.from(formEl.elements)
                    .filter((el) => !(el instanceof HTMLButtonElement));
                const inputs = {};
                formElements
                    .forEach(el => {
                    // The element can be : INPUT (regular or password), TEXTAREA, SELECT,
                    let input = null;
                    const email = el.attributes.getNamedItem("email");
                    if (el instanceof HTMLInputElement && ((email && email.value === "email") || el.type === "email"))
                        el.maxLength = 100;
                    if (el.classList.contains('a-form-input__select'))
                        input = main.createSelectBox(el.parentElement);
                    else if (el.classList.contains('a-form-input__input'))
                        input = el.type === "password" ? main.createPasswordFormInput(el.parentElement) : main.createFormInput(el.parentElement && el.parentElement.parentElement && el.parentElement.parentElement.classList.contains('a-form-input') ? el.parentElement.parentElement : el.parentElement);
                    else if (el instanceof HTMLInputElement && el.type === "hidden")
                        input = main.createHiddenFormInput(el);
                    // If not those 3, it's something else -> leave it alone
                    if (input) {
                        let key = input.inputEl.id.toLowerCase();
                        if (!key)
                            key = input.inputEl.name;
                        inputs[key] = input;
                        input.inputEl.addEventListener('change', () => { isDirty = true; });
                    }
                });
                if (submitOnEnter && submitButtonEl && submitButtonEl.type.toLowerCase() !== "submit") {
                    onKeyUpEvent = eXpress.html.addEventListener(formEl, 'keyup', (ev) => ev.key === "Enter" && onSubmit());
                }
                if (onDirtyNavigateAway) {
                    const links = eXpress.html.querySelectorAll(document, "a");
                    links.forEach((link) => eXpress.html.addEventListener(link, 'click', (event) => {
                        if (!isDirty || eXpress.html.hasClass(formEl, "u-hide"))
                            return;
                        if (event.currentTarget instanceof HTMLAnchorElement) {
                            const url = event.currentTarget.href;
                            if (!url)
                                return;
                            event.preventDefault();
                            onDirtyNavigateAway(url);
                        }
                        return;
                    }));
                    //window.addEventListener("beforeunload", (event) => { if (isDirty) return onDirtyNavigateAway(event); });
                    //html.addEventListener(window, "beforeunload", () => { if (isDirty) return onDirtyNavigateAway(); });
                }
                const validate = () => {
                    resetValidation();
                    const promises = Object.keys(inputs)
                        .map((name) => !inputs[name]["validatePassword"]
                        ? $.when(true)
                        : inputs[name].validatePassword());
                    const isFormValid = validator.validate();
                    const deferred = $.Deferred();
                    Promise.all(promises)
                        .then(x => {
                        const ok = x.every((v) => v === true);
                        deferred.resolve(ok && isFormValid);
                    })
                        .catch(() => {
                        deferred.resolve(false);
                    });
                    return deferred.promise();
                };
                const getInputs = () => Object.keys(inputs).map(key => inputs[key]);
                const getInputByName = (name) => inputs[name.toLowerCase()];
                const dispose = () => {
                    clearAll(true);
                    submitButton.dispose();
                    onKeyUpEvent && onKeyUpEvent.dispose();
                };
                const toggleSubmitButton = (enable) => enable ? submitButton.enable() : submitButton.disable();
                const resetValidation = () => {
                    clearAll();
                    validator.reset();
                };
                const clearAll = (clearValues = false) => {
                    getInputs()
                        .map(input => input.clear(clearValues));
                };
                const setError = (name, error, clear = false) => {
                    const input = getInputByName(name);
                    if (input)
                        input.setError(error, clear);
                };
                const setErrors = (clear = false, ...errors) => {
                    errors.forEach(e => setError(e.name, e.error, clear));
                    if (errors.length) {
                        const input = getInputByName(errors[0].name);
                        if (input)
                            input.inputEl.parentElement.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                };
                const clearInput = (name, clearValue = false) => {
                    const input = getInputByName(name);
                    if (input)
                        input.clear(clearValue);
                };
                const clearInputs = (clearValue = false, ...names) => names.forEach(name => clearInput(name, clearValue));
                const disableForm = (disable) => {
                    getInputs().map(i => disable ? i.disable() : i.enable());
                    resetValidation();
                    toggleSubmitButton(!disable);
                };
                const disableInput = (name) => {
                    const input = getInputByName(name);
                    if (input)
                        input.disable();
                };
                const setValue = (name, value) => {
                    const input = getInputByName(name);
                    if (input)
                        input.setValue(value);
                };
                const setValues = (...values) => values.filter(v => getInputByName(v.name))
                    .forEach(v => setValue(v.name, v.value));
                const formData = () => {
                    const data = {};
                    Object.keys(inputs).forEach(name => data[name] = inputs[name].getValue().toString() || "");
                    return data;
                };
                const hideInput = (name) => {
                    const input = getInputByName(name);
                    if (input)
                        input.hide();
                };
                const showInput = (name) => {
                    const input = getInputByName(name);
                    if (input)
                        input.show();
                };
                const setRequiredOnInput = (name, value) => {
                    const input = getInputByName(name);
                    if (input)
                        input.setRequired(value);
                };
                const disableButton = () => {
                    toggleSubmitButton(false);
                };
                const enableButton = () => {
                    toggleSubmitButton(true);
                };
                return {
                    dispose,
                    disableForm,
                    disableInput,
                    validate,
                    setErrors,
                    clearInputs,
                    clearAll: () => clearAll(true),
                    setValues,
                    hideInput,
                    showInput,
                    inputs,
                    disableButton,
                    enableButton,
                    setRequiredOnInput
                };
            }
            main.initForm = initForm;
            function createFormAddressSuggestor(form) {
                const autocompleteSuggestionClass = "technical-autocomplete-suggestion";
                const autocompleteSuggestionTemplateClass = "technical-autocomplete-suggestion-template";
                const elements = Array.from(form.elements);
                elements.forEach(el => {
                    var _a;
                    const attrValue = el.attributes.getNamedItem('addresssuggestions');
                    if (!attrValue)
                        return;
                    const currentEl = el;
                    const autoCompleteParent = eXpress.html.querySelector((_a = currentEl.parentElement) !== null && _a !== void 0 ? _a : currentEl, '.technical-autocomplete', false);
                    if (!autoCompleteParent)
                        return;
                    // suggestions parameter is billing or delivery
                    const type = attrValue.value;
                    // Address validation always happens on the street, however, we need nr, zip & city values to validate!
                    const useExternalAddressValidationAttr = el.attributes.getNamedItem('useexternaladdressvalidation');
                    const useExternalAddressValidation = (useExternalAddressValidationAttr ? useExternalAddressValidationAttr.value : 'true') === "true";
                    if (!useExternalAddressValidation)
                        return;
                    const suggestionTemplate = eXpress.html.querySelector(autoCompleteParent, "." + autocompleteSuggestionTemplateClass, false);
                    if (!suggestionTemplate)
                        return;
                    const disposableEvents = eXpress.utils.compositeDisposable([]);
                    const inputChanged = (ev) => {
                        const streetEl = ev.target;
                        main.autocompleteAddressAsync(streetEl.value, form.elements.namedItem(type + 'HouseNumber').value, form.elements.namedItem(type + 'ZipCode').value, form.elements.namedItem(type + 'City').value, form.elements.namedItem(type + 'CountryId').value, main.AddressAutocompletionType.Street, 3).then(result => {
                            // remove all existing suggestions
                            const suggestionsToRemove = eXpress.html.querySelectorAll(autoCompleteParent, "." + autocompleteSuggestionClass + ":not(." + autocompleteSuggestionTemplateClass + ")");
                            suggestionsToRemove.forEach(suggestionToRemove => {
                                autoCompleteParent.removeChild(suggestionToRemove);
                            });
                            // remove all previous eventlisteners
                            disposableEvents.dispose();
                            if (!result || !Array.isArray(result) || result.length == 0) {
                                autoCompleteParent.style.display = "";
                                return;
                            }
                            autoCompleteParent.style.display = "block";
                            // add the new suggestions
                            result.forEach(res => {
                                const newSuggestion = suggestionTemplate.cloneNode();
                                newSuggestion.innerHTML = eXpress.utils.capitalizeFirstLetterOfWords(res.street);
                                eXpress.html.removeClass(newSuggestion, autocompleteSuggestionTemplateClass);
                                eXpress.html.removeClass(newSuggestion, "u-hide");
                                // add click event
                                const eventHandlers = [];
                                eventHandlers.push(eXpress.html.addEventListener(newSuggestion, "mousedown", (ev) => ev.preventDefault())); // Wha? If not, the onblur triggers first causing the onclick to never happen
                                eventHandlers.push(eXpress.html.addEventListener(newSuggestion, "click", (ev) => {
                                    let action = "";
                                    if (eXpress.html.hasClass(form, "technical-personal-data"))
                                        action = "ClickedStreetSuggestionPersonalData";
                                    if (eXpress.html.hasClass(form, "technical-delivery-address-form"))
                                        action = "ClickedStreetSuggestionDeliveryOptions";
                                    if (eXpress.html.hasClass(form, "technical-address-form"))
                                        action = "ClickedAddressSuggestionMyAccount";
                                    eXpress.analytics.trackAddressValidationEvent(action);
                                    currentEl.value = ev.currentTarget.innerHTML;
                                    autoCompleteParent.style.display = "";
                                }));
                                if (disposableEvents.add)
                                    disposableEvents.add(eventHandlers);
                                autoCompleteParent.appendChild(newSuggestion);
                            });
                        });
                    };
                    eXpress.html.addEventListener(el, 'keyup', eXpress.utils.debounce(inputChanged, 200));
                    // Onblur, always hide the suggestions
                    eXpress.html.addEventListener(el, 'blur', () => autoCompleteParent.style.display = '');
                });
            }
            main.createFormAddressSuggestor = createFormAddressSuggestor;
            function createFormValidator(form, options = {}) {
                const { errorClass = 'a-form-input--error', validClass = 'a-form-input--validated', onFocusIn = (el) => el.parentElement.classList.remove(errorClass), shouldScrollToFirstError = true, ignore, onValidate } = options;
                $.validator.addMethod("invalidchars", function (value, element) {
                    //@ts-ignore
                    return this.optional(element) || eXpress.utils.isValidWithoutNonAlphaNumericCharsAtEnd(value, element);
                });
                $.validator.addMethod("notonlynumbers", function (value, element) {
                    //@ts-ignore
                    return this.optional(element) || eXpress.utils.canNotContainOnlyNumerics(value);
                });
                $.validator.addMethod("regex", function (value, element, regexp) {
                    //@ts-ignore
                    return this.optional(element) || new RegExp(regexp).test(value);
                });
                $.validator.addMethod("phonenumber", function (value, element, regexp) {
                    //@ts-ignore
                    return this.optional(element) || new RegExp(regexp).test(value);
                });
                $.validator.addMethod("urlsafe", function (value, element) {
                    //@ts-ignore
                    return this.optional(element) || eXpress.utils.isValidTextWithoutAngleBrackets(value);
                });
                $.validator.addMethod("blacklist", function (value, element, blacklist) {
                    if (!blacklist)
                        return true;
                    const list = blacklist.split(',');
                    for (let i = 0; i < list.length; i++)
                        if (value.toLowerCase() === list[i])
                            return false;
                    return true;
                });
                $.validator.addMethod("emailRFC822", function (value, element) {
                    //@ts-ignore
                    return this.optional(element) || eXpress.utils.isValidEmailAddress(value);
                });
                $.validator.addMethod("vat", function (value, element, vat) {
                    //@ts-ignore
                    return this.optional(element) || eXpress.utils.isValidVatNumber(value, vat);
                });
                $.validator.addMethod("personalnumber", function (value, element) {
                    return eXpress.utils.checkPersonalNumber(value, element.dataset.regioncode || "");
                });
                $.validator.addMethod("countrycode", function (value, element) {
                    var _a, _b;
                    const regex = /\+[0-9{2-3}]+.*/g;
                    //@ts-ignore
                    return this.optional(element) || value.length < 21 && ((_b = (_a = regex.exec(value)) === null || _a === void 0 ? void 0 : _a.every(x => x.length > 0)) !== null && _b !== void 0 ? _b : false);
                });
                $.validator.addMethod("usehousenumber", function (value, element, useHouseNumber) {
                    if (!useHouseNumber)
                        return true;
                    const prefix = element.dataset.prefix || "";
                    const houseNumberEl = eXpress.html.querySelector(form, "input[name='" + prefix + "HouseNumber']", false);
                    if (!houseNumberEl || !houseNumberEl.value)
                        return true;
                    const atStart = value.trim().substring(0, houseNumberEl.value.trim().length + 1) === houseNumberEl.value.trim() + ' ';
                    const atEnd = value.trim().substring(value.trim().length - (houseNumberEl.value.trim().length + 1), value.trim().length) === ' ' + houseNumberEl.value.trim();
                    //@ts-ignore
                    return this.optional(element) || !atStart && !atEnd;
                });
                $.validator.addMethod("passwordcheck", function (value) {
                    const passwordEl = eXpress.html.querySelector(form, "input[name='password']", false);
                    if (!passwordEl)
                        return true;
                    //@ts-ignore
                    return value === passwordEl.value;
                });
                $.validator.addMethod("termsrequired", function (value, element) {
                    //@ts-ignore
                    return value || (element && element instanceof HTMLInputElement && element.checked);
                });
                $.validator.addMethod("data-pristine-termsrequired", // .net core view in old site validation
                function (value, element) {
                    //@ts-ignore
                    return value || (element && element instanceof HTMLInputElement && element.checked);
                }, jQuery.validator.messages['termsrequired']);
                /*
                 * The streetsuggestion validator is a special case ... It always returns true (validates), it just shows suggestions.
                 * */
                //$.validator.addMethod(
                //	"streetsuggestion",
                //	function (value, element) {
                //		//@ts-ignore
                //		return true;
                //	}
                //);
                const validator = $(form).validate({
                    errorClass,
                    validClass,
                    errorElement: 'p',
                    errorPlacement: ($error, $input) => {
                        const errorMessage = $error[0].textContent || "";
                        const inputEl = $input[0];
                        const errorEl = eXpress.html.querySelector(inputEl.parentElement, '.a-form-input__error-text', false);
                        if (errorEl)
                            errorEl.innerHTML = errorMessage;
                    },
                    highlight: (el, errorClass, validClass) => {
                        el.parentElement.classList.add(errorClass);
                        el.parentElement.classList.remove(validClass);
                    },
                    unhighlight: (el, errorClass, validClass) => {
                        el.parentElement.classList.remove(errorClass);
                        el.parentElement.classList.add(validClass);
                    },
                    submitHandler: () => false, // we don't want the validator to submit
                    onkeyup: false,
                    onfocusout: false,
                    onfocusin: onFocusIn,
                    showErrors: function (map, list) {
                        if (this.defaultShowErrors)
                            this.defaultShowErrors();
                        if (shouldScrollToFirstError && list.length > 0) {
                            setTimeout(() => list[0].element.parentElement.scrollIntoView({ behavior: "smooth", block: "center" }), 250);
                        }
                    },
                    ignore: ignore
                });
                const validate = () => {
                    if (onValidate)
                        onValidate();
                    return validator.form();
                };
                return {
                    validate,
                    reset: () => validator.resetForm()
                };
            }
            main.createFormValidator = createFormValidator;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createItemInCartUnavailable(deps) {
                let onClickDisposable;
                const init = () => {
                    deps.showItemInCartUnavailablePopup();
                };
                const detachClick = () => onClickDisposable && onClickDisposable.dispose();
                init();
                return {
                    dispose: () => {
                        detachClick();
                    }
                };
            }
            main.createItemInCartUnavailable = createItemInCartUnavailable;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createDropDownKeyboardNavigator(containerEl, deps) {
                const selectedClass = "selected";
                const getElementToFocus = (el) => {
                    if (el instanceof HTMLAnchorElement || el instanceof HTMLButtonElement || el instanceof HTMLInputElement) {
                        return el;
                    }
                    else {
                        return eXpress.html.querySelector(el, "a, button, input") || el;
                    }
                };
                const onArrowDown = (e) => {
                    e.preventDefault();
                    if (deps.onBeforeArrowDown) {
                        closeOtherDropDowns();
                        deps.onBeforeArrowDown();
                    }
                    if (!deps.dropdownItemEls || deps.dropdownItemEls.length === 0)
                        return;
                    const focusedEl = deps.dropdownItemEls.find((el) => eXpress.html.hasClass(el, selectedClass));
                    if (focusedEl) {
                        eXpress.html.removeClass(focusedEl, selectedClass);
                        const indexOfFocusedEl = Array.prototype.indexOf.call(deps.dropdownItemEls, focusedEl);
                        const nextEl = deps.dropdownItemEls[indexOfFocusedEl + 1];
                        if (nextEl) {
                            getElementToFocus(nextEl).focus();
                            eXpress.html.addClass(nextEl, selectedClass);
                        }
                        else {
                            getElementToFocus(deps.dropdownItemEls[0]).focus();
                            eXpress.html.addClass(deps.dropdownItemEls[0], selectedClass);
                        }
                    }
                    else {
                        getElementToFocus(deps.dropdownItemEls[0]).focus();
                        eXpress.html.addClass(deps.dropdownItemEls[0], selectedClass);
                    }
                };
                const onArrowUp = (e) => {
                    e.preventDefault();
                    if (deps.onBeforeArrowUp)
                        deps.onBeforeArrowUp();
                    if (!deps.dropdownItemEls || deps.dropdownItemEls.length === 0)
                        return;
                    const focusedEl = deps.dropdownItemEls.find((el) => eXpress.html.hasClass(el, selectedClass));
                    if (focusedEl) {
                        eXpress.html.removeClass(focusedEl, selectedClass);
                        const indexOfFocusedEl = Array.prototype.indexOf.call(deps.dropdownItemEls, focusedEl);
                        const prevEl = deps.dropdownItemEls[indexOfFocusedEl - 1];
                        if (prevEl) {
                            getElementToFocus(prevEl).focus();
                            eXpress.html.addClass(prevEl, selectedClass);
                        }
                        else {
                            getElementToFocus(deps.dropdownItemEls[deps.dropdownItemEls.length - 1]).focus();
                            eXpress.html.addClass(deps.dropdownItemEls[deps.dropdownItemEls.length - 1], selectedClass);
                        }
                    }
                    else {
                        getElementToFocus(deps.dropdownItemEls[deps.dropdownItemEls.length - 1]).focus();
                        eXpress.html.addClass(deps.dropdownItemEls[deps.dropdownItemEls.length - 1], selectedClass);
                    }
                };
                const onEnter = (e) => {
                    if (!deps.dropdownItemEls)
                        return;
                    closeOtherDropDowns();
                    const focusedEl = deps.dropdownItemEls.find((el) => eXpress.html.hasClass(el, selectedClass));
                    if (focusedEl)
                        eXpress.html.removeClass(focusedEl, selectedClass);
                    deps.onEnter(e);
                };
                const onEscape = (e) => {
                    if (!deps.dropdownItemEls)
                        return;
                    const focusedEl = deps.dropdownItemEls.find((el) => eXpress.html.hasClass(el, selectedClass));
                    if (focusedEl)
                        eXpress.html.removeClass(focusedEl, selectedClass);
                    deps.onEscape(e);
                };
                const onKeyDown = (e) => {
                    if (e.key === "Enter")
                        onEnter(e);
                    if (e.key === "Escape")
                        onEscape(e);
                    if (e.key === "ArrowUp" && (deps.dropdownItemEls || deps.onArrowUp))
                        deps.dropdownItemEls ? onArrowUp(e) : deps.onArrowUp && deps.onArrowUp(e);
                    if (e.key === "ArrowDown" && (deps.dropdownItemEls || deps.onArrowDown))
                        deps.dropdownItemEls ? onArrowDown(e) : deps.onArrowDown && deps.onArrowDown(e);
                };
                const closeOtherDropDowns = () => {
                    const openDropdowns = eXpress.html.querySelectorAll(document, ".menu-is-open, .a-language-selector--open");
                    openDropdowns.forEach((dropdown) => {
                        eXpress.html.removeClass(dropdown, "menu-is-open");
                        eXpress.html.removeClass(dropdown, "a-language-selector--open");
                    });
                };
                return eXpress.html.addEventListener(containerEl, "keydown", onKeyDown);
            }
            main.createDropDownKeyboardNavigator = createDropDownKeyboardNavigator;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initLanguageSelector(buttonEl) {
                let eventDisposables;
                let onDocumentClickDisposable;
                const openClassName = "a-language-selector--open";
                const openMenu = () => {
                    buttonEl.classList.add(openClassName);
                    attachOnDocumentClick();
                };
                const isClosed = () => !buttonEl.classList.contains(openClassName);
                const closeMenu = () => {
                    buttonEl.classList.remove(openClassName);
                    detachDocumentClick();
                };
                const onDocumentClick = (e) => {
                    if (!e.target.closest(".technical-language-selector, .technical-language-selector-choices")) {
                        closeMenu();
                    }
                };
                const onButtonClick = () => {
                    // we do don't want to load or attach handlers when the menu is closing
                    if (!buttonEl.classList.contains(openClassName))
                        attachOnDocumentClick();
                    buttonEl.classList.toggle(openClassName);
                };
                const attachOnDocumentClick = () => (onDocumentClickDisposable = eXpress.utils.compositeDisposable([eXpress.html.addEventListener(document, 'click', onDocumentClick, true)]));
                const detachDocumentClick = () => onDocumentClickDisposable && onDocumentClickDisposable.dispose();
                const init = () => {
                    eventDisposables = eXpress.utils.compositeDisposable([
                        eXpress.html.addEventListener(buttonEl, 'click', onButtonClick)
                    ]);
                    if (!eXpress.html.isMobile()) { // @ts-ignore
                        eventDisposables.add([main.createDropDownKeyboardNavigator(buttonEl, {
                                onEscape: closeMenu,
                                onEnter: openMenu,
                                onBeforeArrowDown: () => {
                                    if (isClosed())
                                        openMenu();
                                },
                                dropdownItemEls: eXpress.html.querySelectorAll(buttonEl, ".a-language-selector__link"),
                            })]);
                    }
                };
                const deInit = () => {
                    dispose();
                    closeMenu();
                };
                // remove all handlers
                const dispose = () => {
                    if (eventDisposables)
                        eventDisposables.dispose();
                    detachDocumentClick();
                };
                // init component
                init();
                return {
                    deInit,
                    dispose,
                };
            }
            main.initLanguageSelector = initLanguageSelector;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
/// <reference path="../../../../typings/window.d.ts" />
/// <reference path="../../../../typings/lottie.d.ts" />
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            class MainNavigation {
                constructor(containerEl, deps) {
                    this.toggleScroll = () => !this.getScrollingElement().classList.contains('u-no-scroll-mobile')
                        ? this.getScrollingElement().classList.add('u-no-scroll-mobile')
                        : this.getScrollingElement().classList.remove('u-no-scroll-mobile');
                    this.getScrollingElement = () => (document.scrollingElement || document.documentElement);
                    this.mainNavigationEl = containerEl;
                    this.mobileMenuEl = eXpress.html.querySelector(this.mainNavigationEl, "#technical-mobile-menu", false);
                    this.mainNavigationDependencies = deps;
                    this.isMobile = () => eXpress.html.isMobileOnPageWithHeader();
                    this.initComponents();
                }
                initEventAnimation() {
                    const eventContainer = eXpress.html.querySelector(this.mainNavigationEl, '.technical-event-container', false);
                    if (!eventContainer || !window['lottie'])
                        return {
                            toggleEventVisibility: () => { return; }
                        };
                    const imageContainer = eXpress.html.querySelector(this.mainNavigationEl, '.technical-animate-img', true);
                    const seen = eXpress.utils.getCookie('evSeen') && eXpress.utils.getCookie('evSeen') === '1';
                    const stickyNav = eventContainer.dataset.stickynav === 'true';
                    const mobile = this.isMobile();
                    const animation = lottie.loadAnimation({
                        container: imageContainer,
                        renderer: 'svg', // Choose the renderer
                        loop: false,
                        autoplay: false,
                        path: window.context.cdn + imageContainer.dataset.catimage,
                        initialSegment: seen ? [255, 354] : [0, 354]
                    });
                    animation.addEventListener('complete', function () {
                        // Loop the last 4 seconds of the animation continuously
                        animation.playSegments([255, 354], true);
                    });
                    const animate = eXpress.html.querySelector(eventContainer, `.technical-animate-img`, true);
                    animate.style.transition = "opacity 0.5s";
                    animate.style.opacity = "1";
                    const eventContainerInitialHeight = eventContainer.clientHeight;
                    const toggleEventVisibility = (visiblePx) => {
                        if (!mobile) {
                            imageContainer.style.opacity = `${1 - ((100 / 70) * visiblePx) / 100}`;
                            return;
                        }
                        eventContainer.style.opacity = `${1 - ((100 / 70) * visiblePx) / 100}`; // Changes the opacity on scroll
                        eventContainer.style.height = `${eventContainerInitialHeight - ((100 / 70) * visiblePx) / 5}px`; // Slightly collapses the evenContainer for a nice effect
                        if (stickyNav) {
                            const mobileSearchBar = eXpress.html.querySelector(this.mainNavigationEl, '.technical-mobile-searchbar', true);
                            mobileSearchBar.style.top = `${130 - visiblePx}px`; // Lets the scrollbar go to its fixed place when scrolling
                        }
                    };
                    if (stickyNav)
                        document.addEventListener('scroll', _ => !this.getScrollingElement().classList.contains('u-no-scroll-mobile') && toggleEventVisibility(mobile ? window.scrollY > eventContainerInitialHeight ? eventContainerInitialHeight : window.scrollY : 0));
                    animation.play();
                    if (!seen)
                        eXpress.utils.writeCookieThatExpiresAtTheEndOfTheDay('evSeen', '1');
                    return {
                        toggleEventVisibility: (hide) => toggleEventVisibility(hide ? eventContainerInitialHeight : 0)
                    };
                }
                initComponents() {
                    const eventAnimation = this.initEventAnimation();
                    // Mobile Menu
                    const onOpen = () => { eventAnimation.toggleEventVisibility(true); };
                    const onClose = () => { eventAnimation.toggleEventVisibility(false); };
                    this.initMobileMenu(onOpen, onClose);
                    const loadDesktopMenuItemAsync = (firstLevel = -1, secondLevel = -1) => {
                        if (secondLevel < 0)
                            return $.ajax({ url: "/apicore/header/desktopmenu?indexLevel1=" + firstLevel, traditional: true }).then(res => res);
                        else
                            return $.ajax({ url: "/apicore/header/desktopmenu?indexLevel1=" + firstLevel + "&indexLevel2=" + secondLevel, traditional: true }).then(res => res);
                    };
                    // Desktop Menu
                    const navigationDesktopEl = eXpress.html.querySelector(this.mainNavigationEl, '.technical-navigation-desktop', false);
                    navigationDesktopEl && main.CreateNavigationDesktop(navigationDesktopEl);
                    const desktopLeftMenuEl = eXpress.html.querySelector(this.mainNavigationEl, '.technical-desktop-left-menu', false);
                    if (desktopLeftMenuEl) {
                        main.initNavigationDesktop(desktopLeftMenuEl, { loadDesktopMenuItemAsync });
                    }
                    // Language Selector
                    const langButtonEl = eXpress.html.querySelector(this.mainNavigationEl, ".technical-language-selector", false);
                    langButtonEl && main.initLanguageSelector(langButtonEl);
                    const searchBarEl = eXpress.html.querySelector(this.mainNavigationEl, ".o-main-navigation__searchbar", false);
                    if (searchBarEl) {
                        main.initSearchBar(searchBarEl, eXpress.html.querySelector(this.mainNavigationEl, ".o-icon-navigation__search-bar", true), (searchTerm) => $.ajax({ url: "/apicore/searchapi/autocomplete", type: "GET", data: { searchTerm } }).then((res) => res), () => { !this.isMobile() && eventAnimation.toggleEventVisibility(true); }, () => { !this.isMobile() && eventAnimation.toggleEventVisibility(false); });
                    }
                    // Notification Center
                    const notificationCenterEl = eXpress.html.querySelector(this.mainNavigationEl, '.o-icon-navigation__notifications-center', false);
                    if (notificationCenterEl) {
                        components.main.createNotificationCenter(notificationCenterEl, {
                            getNotifications: () => $.ajax({ url: "/apicore/header/loadnotificationtiles", cache: false })
                                .then(res => res),
                            isMobile: this.isMobile,
                            markNotificationsAsRead: (notificationIds) => $.ajax({
                                url: "/apicore/header/marknotificationasread",
                                type: "POST",
                                data: { notificationIds },
                                traditional: true,
                            }).then((res) => res),
                            onOpen: () => { this.isMobile() && eventAnimation.toggleEventVisibility(true); this.toggleScroll(); },
                            onClose: () => { eventAnimation.toggleEventVisibility(false); this.toggleScroll(); },
                        });
                    }
                    // My-Account
                    const myAccountMenuEl = eXpress.html.querySelector(this.mainNavigationEl, '.o-icon-navigation__user-menu', false);
                    if (myAccountMenuEl) {
                        main.initMyAccount(this.mainNavigationEl, {
                            getIconsAsync: this.mainNavigationDependencies.getIconsAsync,
                            isMobile: this.isMobile,
                            onOpen: () => { this.isMobile() && eventAnimation.toggleEventVisibility(true); this.toggleScroll(); },
                            onClose: () => { eventAnimation.toggleEventVisibility(false); this.toggleScroll(); },
                            loadAccountMenu: () => $.ajax({ url: "/apicore/header/loadmyaccount" }).then((res) => res),
                        });
                    }
                    const leadTimesBarEl = eXpress.html.querySelector(this.mainNavigationEl, '.technical-leadtimes', false);
                    if (leadTimesBarEl) {
                        main.createClickableElement(leadTimesBarEl, this.mainNavigationDependencies.openLeadTimesPopupAsync);
                        eXpress.utils.getParameter('leadtimes') === 'true' && leadTimesBarEl.click();
                    }
                    // init countdowns on value propositions
                    const topBarContainerEl = eXpress.html.querySelector(this.mainNavigationEl, '.technical-top-bar-container', false);
                    if (topBarContainerEl) {
                        const countDownEls = eXpress.html.querySelectorAll(topBarContainerEl, ".technical-countdown");
                        countDownEls.forEach(el => {
                            const countDownToDate = el.dataset.countdown || "";
                            const daysLabel = el.dataset.dayslabel || "";
                            const dayLabel = el.dataset.daylabel || "";
                            if (countDownToDate !== "") {
                                const onCountDownFinish = () => {
                                    const barEls = eXpress.html.querySelectorAll(topBarContainerEl, ".technical-top-bar");
                                    if (barEls.length === 1) {
                                        // Hide container
                                        eXpress.html.hide(topBarContainerEl);
                                    }
                                    else {
                                        // delete own top bar
                                        const myTopBar = eXpress.html.getParentWithClassName(el, "technical-top-bar");
                                        myTopBar && myTopBar.remove();
                                        // switch container to single
                                        topBarContainerEl.classList.remove("m-top-bar--combo");
                                        topBarContainerEl.classList.add("m-top-bar--single");
                                        // remove div around other top bar
                                        const otherTopBar = barEls.filter(el => el !== myTopBar)[0];
                                        if (otherTopBar)
                                            otherTopBar.outerHTML = otherTopBar.innerHTML;
                                    }
                                };
                                main.initCountDown(topBarContainerEl, el, countDownToDate, { showDays: true, onCountDownFinish: onCountDownFinish, daysLabel, dayLabel });
                            }
                        });
                    }
                }
                initMobileMenu(onOpen, onClose) {
                    if (this.mobileMenuEl) {
                        const oldMobileMenuContainerEl = eXpress.html.querySelector(document, ".technical-mobile-navigation-hamburger-menu-container", false);
                        const menuButtonEl = eXpress.html.querySelector(document, ".technical-mobile-navigation-hamburger-menu-button", true);
                        if (oldMobileMenuContainerEl) {
                            main.initNavigationMobile({
                                mobileMenuEl: this.mobileMenuEl,
                                containerEl: eXpress.html.querySelector(document, ".technical-mobile-navigation", true),
                                menuButtonEl: menuButtonEl,
                                menuContainerEl: oldMobileMenuContainerEl,
                            }, {
                                getMobileMenu: (indexLevel2, indexLevel3) => $.ajax({
                                    url: "/apicore/header/mobilemenu",
                                    data: {
                                        indexLevel2: indexLevel2 !== null && indexLevel2 !== void 0 ? indexLevel2 : -1,
                                        indexLevel3: indexLevel3 !== null && indexLevel3 !== void 0 ? indexLevel3 : -1,
                                        pageId: this.mobileMenuEl && this.mobileMenuEl.getAttribute("data-page-id")
                                    }, cache: false
                                })
                                    .then(res => res),
                                getIconsAsync: this.mainNavigationDependencies.getIconsAsync,
                                onClose: () => {
                                    onClose();
                                    this.toggleScroll();
                                },
                                onOpen: () => {
                                    onOpen();
                                    this.toggleScroll();
                                },
                            });
                        }
                        else {
                            main.initNavigationMobileNew(this.mobileMenuEl, menuButtonEl, {
                                getMobileMenu: (indexLevel2, indexLevel3) => $.ajax({
                                    url: "/apicore/headerapi/mobilemenu",
                                    data: {
                                        indexLevel2: indexLevel2 !== null && indexLevel2 !== void 0 ? indexLevel2 : -1,
                                        indexLevel3: indexLevel3 !== null && indexLevel3 !== void 0 ? indexLevel3 : -1,
                                        pageId: this.mobileMenuEl && this.mobileMenuEl.getAttribute("data-page-id")
                                    }, cache: false
                                })
                                    .then(res => res),
                                getIconsAsync: this.mainNavigationDependencies.getIconsAsync,
                                onClose: () => {
                                    onClose();
                                    this.toggleScroll();
                                },
                                onOpen: () => {
                                    onOpen();
                                    this.toggleScroll();
                                }
                            });
                        }
                    }
                }
            }
            main.MainNavigation = MainNavigation;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initMyAccount(mainNavigationEl, deps) {
                const { getIconsAsync, onClose, onOpen, isMobile, loadAccountMenu } = deps;
                let onDocumentClickDisposable;
                let keyboardNavigatorDisposables;
                const icons = {};
                let loaded = false;
                const myAccountContainerEl = eXpress.html.querySelector(mainNavigationEl, ".o-icon-navigation__user", true);
                const buttonEl = eXpress.html.querySelector(myAccountContainerEl, '.o-icon-navigation__user-icon', true);
                const menuEl = eXpress.html.querySelector(myAccountContainerEl, '.o-icon-navigation__user-menu', true);
                const overLayEl = eXpress.html.querySelector(menuEl, '.technical-navigation-overlay', true);
                const contentEl = eXpress.html.querySelector(overLayEl, '.m-navigation-overlay__content', true);
                const closeButtonEl = eXpress.html.querySelector(overLayEl, '.m-navigation-overlay__close-container', true);
                const setOverLayClass = () => {
                    overLayEl.classList.remove(...["m-navigation-overlay__mobile-view", "m-navigation-overlay__desktop-view"]);
                    overLayEl.classList.add(isMobile() ? "m-navigation-overlay__mobile-view" : "m-navigation-overlay__desktop-view");
                };
                const onOpenMyAccount = () => {
                    if (!loaded) {
                        return loadAccountMenu()
                            .then(res => {
                            onOpen && onOpen();
                            contentEl.insertAdjacentHTML('beforeend', res);
                            const buttonEls = eXpress.html.querySelectorAll(contentEl, '.technical-hassvg');
                            const urls = buttonEls
                                .filter(el => !!el.getAttribute('data-icon-svg'))
                                .map(el => el.getAttribute('data-icon-svg'))
                                .filter((value, index, self) => self.indexOf(value) === index);
                            // this can fire & forget
                            getIconsAsync(urls)
                                .then(res => {
                                res.forEach(icon => icons[icon.url] = icon.svg);
                                buttonEls.forEach(el => el.insertAdjacentHTML('beforeend', icons[el.getAttribute('data-icon-svg')]));
                            });
                            if (!isMobile()) {
                                keyboardNavigatorDisposables.dispose();
                                // @ts-ignore
                                keyboardNavigatorDisposables.add([main.createDropDownKeyboardNavigator(myAccountContainerEl, {
                                        onEnter: onButtonClick,
                                        onEscape: onCloseIconClick,
                                        onBeforeArrowDown: () => {
                                            if (!menuEl.classList.contains("menu-is-open"))
                                                openMenu();
                                        },
                                        dropdownItemEls: eXpress.html.querySelectorAll(contentEl, ".m-navigation-mobile-ui"),
                                    })]);
                            }
                            loaded = true;
                        });
                    }
                    else {
                        onOpen && onOpen();
                        return $.Deferred().resolve().promise();
                    }
                };
                const closeMenu = () => {
                    onClose && onClose();
                    menuEl.classList.remove("menu-is-open");
                    detachDocumentClick();
                    return $.Deferred().resolve().promise();
                };
                const openMenu = () => {
                    setOverLayClass();
                    return onOpenMyAccount()
                        // @ts-ignore
                        .then(() => {
                        menuEl.classList.add("menu-is-open");
                        if (isMobile()) {
                            const menuButtonList = eXpress.html.querySelector(menuEl, '.o-my-account__list', true);
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuButtonList);
                        }
                        attachOnDocumentClick();
                    });
                };
                const onCloseIconClick = (e) => {
                    e.stopPropagation();
                    closeMenu();
                };
                const onButtonClick = () => {
                    return menuEl.classList.contains("menu-is-open")
                        ? closeMenu()
                        : openMenu();
                };
                const onDocumentClick = (e) => {
                    if (!e.target.closest(".o-icon-navigation__user-menu, .o-icon-navigation__user-icon")) {
                        closeMenu();
                    }
                };
                const button = main.createClickableElement(buttonEl, onButtonClick);
                const eventDisposables = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(closeButtonEl, 'click', onCloseIconClick),
                    eXpress.html.addEventListener(window, 'resize', setOverLayClass)
                ]);
                const attachOnDocumentClick = () => (onDocumentClickDisposable = eXpress.html.addEventListener(document, 'click', onDocumentClick, true));
                const detachDocumentClick = () => onDocumentClickDisposable && onDocumentClickDisposable.dispose();
                if (!isMobile()) {
                    keyboardNavigatorDisposables = eXpress.utils.compositeDisposable([
                        main.createDropDownKeyboardNavigator(myAccountContainerEl, {
                            onEnter: onButtonClick,
                            onEscape: onCloseIconClick,
                            onBeforeArrowDown: () => {
                                if (!menuEl.classList.contains("menu-is-open"))
                                    openMenu();
                            },
                            dropdownItemEls: [],
                        }),
                    ]);
                }
                return {
                    dispose: () => {
                        eventDisposables.dispose();
                        detachDocumentClick();
                        button.dispose();
                        closeMenu();
                    }
                };
            }
            main.initMyAccount = initMyAccount;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function CreateNavigationDesktop(container) {
                const HIDE_CLASS = "u-hide";
                const OVERLAY_THIRD_LEVEL_CLASS = "o-navigation-desktop__overlay--full-width";
                const firstLevel = container.querySelector(".technical-navigation-first-level");
                const secondLevel = container.querySelector(".technical-navigation-second-level");
                const thirdLevel = container.querySelector(".technical-navigation-third-level");
                const navigationOverlay = container.querySelector(".technical-navigation-overlay");
                const navigationHoverContainer = container.querySelector(".technical-navigation-hover-container");
                let firstLevelActiveIndex = -1;
                let secondLevelActiveIndex = -1;
                if (!navigationOverlay || !firstLevel || !secondLevel || !thirdLevel || !navigationHoverContainer)
                    throw new Error("Navigation elements are required");
                const updateHoverableNavigationSection = () => {
                    navigationHoverContainer.style.height = `${navigationOverlay.offsetHeight + 20}px`;
                    navigationHoverContainer.style.top = `${navigationOverlay.offsetTop}px`;
                };
                const secondLevelComponent = CreateNavigationDesktopSecondLevel(secondLevel, {
                    activatedElement: (el) => toggleThirdLevelMenu(el),
                    getActiveIndex: () => {
                        return firstLevelActiveIndex.toString();
                    },
                });
                const firstLevelComponent = CreateNavigationDesktopFirstLevel(firstLevel, {
                    activatedElement: (el) => toggleMenu(el),
                    getActiveIndex: () => {
                        return '';
                    }, // 0 level never active
                });
                const thirdLevelComponent = CreateNavigationDesktopThirdLevel(thirdLevel, {
                    activatedElement: (el) => {
                        return; // does not use deeper levels
                    },
                    getActiveIndex: () => {
                        return `${firstLevelActiveIndex}.${secondLevelActiveIndex}`;
                    },
                });
                const closeMenu = () => {
                    firstLevelComponent.close();
                    toggleMenu();
                    toggleThirdLevelMenu();
                };
                const toggleMenu = (el) => __awaiter(this, void 0, void 0, function* () {
                    navigationOverlay.classList.toggle(OVERLAY_THIRD_LEVEL_CLASS, false);
                    if (!(el === null || el === void 0 ? void 0 : el.dataset.menuItem) || el.dataset.hasSecondLevel === "false") {
                        navigationOverlay.style.left = "";
                        navigationOverlay.classList.add(HIDE_CLASS);
                        secondLevelComponent.close();
                        thirdLevelComponent === null || thirdLevelComponent === void 0 ? void 0 : thirdLevelComponent.close();
                        firstLevelActiveIndex = -1;
                        updateHoverableNavigationSection();
                        return;
                    }
                    firstLevelActiveIndex = parseInt(el.dataset.menuItem, 10);
                    const isOpened = yield secondLevelComponent.open(el.dataset.menuItem);
                    if (!isOpened)
                        return;
                    thirdLevelComponent === null || thirdLevelComponent === void 0 ? void 0 : thirdLevelComponent.close();
                    navigationOverlay.classList.remove(HIDE_CLASS);
                    // subtract left padding on the first-level container so overlay aligns with visible items
                    const containerRect = container.getBoundingClientRect();
                    const elRect = el.getBoundingClientRect();
                    const firstLevelPaddingLeft = firstLevel ? parseFloat(window.getComputedStyle(firstLevel).paddingLeft) || 0 : 0;
                    navigationOverlay.style.left = `${elRect.left - containerRect.left - firstLevelPaddingLeft}px`;
                    updateHoverableNavigationSection();
                });
                const toggleThirdLevelMenu = (el) => __awaiter(this, void 0, void 0, function* () {
                    navigationOverlay.classList.toggle(OVERLAY_THIRD_LEVEL_CLASS, el && el.dataset.hasThirdLevel === "true");
                    if (!(el === null || el === void 0 ? void 0 : el.dataset.menuItem) || firstLevelActiveIndex < 0 || el.dataset.hasThirdLevel === "false") {
                        thirdLevelComponent === null || thirdLevelComponent === void 0 ? void 0 : thirdLevelComponent.close();
                        updateHoverableNavigationSection();
                        return;
                    }
                    secondLevelActiveIndex = parseInt(el.dataset.menuItem, 10);
                    const sideContainerDeps = {
                        title: el.dataset.overviewtitle,
                        link: el.dataset.link,
                        imageUrl: el.dataset.imageUrl,
                    };
                    const isOpened = yield (thirdLevelComponent === null || thirdLevelComponent === void 0 ? void 0 : thirdLevelComponent.open(`${firstLevelActiveIndex}.${secondLevelActiveIndex}`, sideContainerDeps));
                    if (!isOpened)
                        return;
                    updateHoverableNavigationSection();
                });
                container.addEventListener("mouseleave", () => closeMenu());
                document.addEventListener("pointerdown", (e) => {
                    if (!container.contains(e.target))
                        closeMenu();
                });
                navigationHoverContainer.addEventListener("click", () => closeMenu());
                navigationOverlay.addEventListener("mouseleave", () => {
                    if (secondLevelActiveIndex < 0)
                        return;
                    secondLevelComponent.resetSelected();
                });
            }
            main.CreateNavigationDesktop = CreateNavigationDesktop;
            function CreateNavigationDesktopSecondLevel(container, deps) {
                const ACTIVE_CLASS = "m-navigation-desktop-second-level__item--active";
                const CLOSE_CLASS = "u-hide";
                const LOADING_CLASS = "skeleton-loading";
                const loading = {}; // save the firstlevelindex with there loading sate
                const { activatedElement, getActiveIndex } = deps;
                let menuItems = container.querySelectorAll(".technical-navigation-item");
                menuItems.forEach((x) => {
                    x.addEventListener("click", () => {
                        activatedElement(x);
                        menuItems.forEach((ni) => ni.classList.toggle(ACTIVE_CLASS, ni === x));
                    });
                    x.addEventListener("mouseover", () => {
                        if (eXpress.utils.isTouchDevice())
                            return;
                        activatedElement(x);
                        menuItems.forEach((ni) => ni.classList.toggle(ACTIVE_CLASS, ni === x));
                    });
                });
                const open = (firstLevelIndex) => __awaiter(this, void 0, void 0, function* () {
                    const secondMenuAlreadyLoaded = container.querySelector(`.technical-navigation-item[data-parent-index='${firstLevelIndex}'][data-has-third-level]`);
                    if (!secondMenuAlreadyLoaded && !loading[firstLevelIndex]) {
                        loading[firstLevelIndex] = true;
                        container.classList.toggle(CLOSE_CLASS, false);
                        container.classList.toggle(LOADING_CLASS, true);
                        const request = yield eXpress.utils.getHtmlRequest(`apicore/headerapi/desktopmenu?indexLevel1=${firstLevelIndex}`);
                        const requestNode = eXpress.utils.htmlToElement(request);
                        const secondLevelItems = requestNode.querySelectorAll(`.technical-navigation-item[data-parent-index='${firstLevelIndex}'][data-has-third-level]`);
                        // add items to DOM && javascript variable
                        const isStillActiveIndex = getActiveIndex() === firstLevelIndex;
                        secondLevelItems.forEach((x) => {
                            x.addEventListener("click", () => {
                                activatedElement(x);
                                menuItems.forEach((ni) => ni.classList.toggle(ACTIVE_CLASS, ni === x));
                            });
                            x.addEventListener("mouseover", () => {
                                if (eXpress.utils.isTouchDevice())
                                    return;
                                activatedElement(x);
                                menuItems.forEach((ni) => ni.classList.toggle(ACTIVE_CLASS, ni === x));
                            });
                            x.classList.toggle(CLOSE_CLASS, !isStillActiveIndex);
                            container.appendChild(x);
                        });
                        menuItems = container.querySelectorAll(".technical-navigation-item");
                        loading[firstLevelIndex] = false;
                        if (!isStillActiveIndex)
                            return false; // don't update item not active anymore
                    }
                    menuItems.forEach((x) => {
                        const active = x.dataset.parentIndex === firstLevelIndex;
                        x.classList.toggle(CLOSE_CLASS, !active);
                        x.classList.toggle(ACTIVE_CLASS, false); // on open => no second level item selected yet (select on hover or click item)
                    });
                    container.classList.toggle(LOADING_CLASS, !!loading[firstLevelIndex]);
                    container.classList.toggle(CLOSE_CLASS, false);
                    return true;
                });
                const close = () => {
                    container.classList.toggle(CLOSE_CLASS, true);
                    menuItems.forEach((ni) => ni.classList.toggle(ACTIVE_CLASS, false));
                };
                return {
                    open,
                    close,
                    resetSelected: () => menuItems.forEach((ni) => ni.dataset.hasThirdLevel === "false" && ni.classList.toggle(ACTIVE_CLASS, false)),
                };
            }
            main.CreateNavigationDesktopSecondLevel = CreateNavigationDesktopSecondLevel;
            function CreateNavigationDesktopFirstLevel(container, deps) {
                const ACTIVE_CLASS = "m-navigation-desktop-first-level__list-item--active";
                const navigationItems = container.querySelectorAll(".technical-navigation-item");
                const { activatedElement } = deps;
                navigationItems.forEach((x) => {
                    x.addEventListener("click", () => {
                        activatedElement(x);
                        navigationItems.forEach((ni) => ni.classList.toggle(ACTIVE_CLASS, ni === x));
                    });
                    x.addEventListener("mouseover", () => {
                        if (eXpress.utils.isTouchDevice())
                            return;
                        activatedElement(x);
                        navigationItems.forEach((ni) => ni.classList.toggle(ACTIVE_CLASS, ni === x));
                    });
                });
                return {
                    close: () => { navigationItems.forEach((ni) => ni.classList.toggle(ACTIVE_CLASS, false)); }
                };
            }
            main.CreateNavigationDesktopFirstLevel = CreateNavigationDesktopFirstLevel;
            function CreateNavigationDesktopThirdLevel(container, deps) {
                const { getActiveIndex } = deps;
                const HIDE_CLASS = "u-hide";
                const CONTAINER_HIDE_CLASS = "o-navigation-desktop__third-level--hidden";
                const LOADING_CLASS = "skeleton-loading";
                const loading = {}; // save the first and second level index with there loading sate
                const thirdLevelGrid = container.querySelector(".technical-navigation-third-level-grid");
                const sideContainer = container.querySelector(".technical-navigation-third-level-side");
                if (!thirdLevelGrid || !sideContainer)
                    return;
                let menuItems = thirdLevelGrid.querySelectorAll(".technical-navigation-item");
                const gridItems = thirdLevelGrid.querySelectorAll(".technical-navigation-grid-item");
                let overviewPageLinks = container.querySelectorAll(".technical-overview-link");
                const addEventListenersToMenuItem = (x) => {
                    const itemAction = x.querySelector(".technical-navigation-third-level-side-link") || x;
                    itemAction.addEventListener("mouseover", () => {
                        !eXpress.utils.isTouchDevice() &&
                            updateSideContaier({
                                imageUrl: x.dataset.imageUrl || "",
                                link: x.dataset.link || "",
                            });
                    });
                    itemAction.addEventListener("mouseleave", () => {
                        updateSideContaier({
                            imageUrl: sideContainer.dataset.imageUrl || "",
                            link: sideContainer.dataset.link || "",
                        });
                    });
                };
                gridItems.forEach((x) => addEventListenersToMenuItem(x));
                const open = (index, sideContainerDeps) => __awaiter(this, void 0, void 0, function* () {
                    const menuLevelParts = index.split(".");
                    const firstLevelIndex = menuLevelParts[0];
                    const secondLevelActiveIndex = menuLevelParts[1];
                    const thirdMenuAlreadyLoaded = container.querySelector(`.technical-navigation-item.m-navigation-desktop-third-level__group[data-parent-index='${index}']`);
                    const loadingKey = index;
                    if (!thirdMenuAlreadyLoaded && !loading[loadingKey]) {
                        loading[loadingKey] = true;
                        container.classList.toggle(CONTAINER_HIDE_CLASS, false);
                        thirdLevelGrid.classList.toggle(HIDE_CLASS, false);
                        sideContainer.classList.toggle(HIDE_CLASS, false);
                        container.classList.toggle(LOADING_CLASS, true);
                        const request = yield eXpress.utils.getHtmlRequest(`apicore/headerapi/desktopmenu?indexLevel1=${firstLevelIndex}&indexLevel2=${secondLevelActiveIndex}`);
                        const requestNode = eXpress.utils.htmlToElement(request);
                        const thirdLevelOverviewItem = requestNode.querySelectorAll(`.technical-overview-link[data-parent-index='${index}']`);
                        const thirdLevelItems = requestNode.querySelectorAll(`.technical-navigation-item.m-navigation-desktop-third-level__group[data-parent-index='${index}']`);
                        // add items to DOM && javascript variable
                        const isStillActiveIndex = getActiveIndex() === secondLevelActiveIndex;
                        const thirdLevelGridIems = requestNode.querySelectorAll(".technical-navigation-grid-item");
                        thirdLevelGridIems.forEach((x) => addEventListenersToMenuItem(x));
                        thirdLevelItems.forEach((x) => {
                            x.classList.toggle(HIDE_CLASS, !isStillActiveIndex);
                            thirdLevelGrid.appendChild(x);
                        });
                        menuItems = container.querySelectorAll(".technical-navigation-item");
                        loading[loadingKey] = false;
                        thirdLevelOverviewItem.forEach((x) => {
                            x.classList.toggle(HIDE_CLASS, !isStillActiveIndex);
                            container.prepend(x);
                        });
                        overviewPageLinks = container.querySelectorAll(".technical-overview-link");
                        if (!isStillActiveIndex)
                            return false; // don't update item not active anymore
                    }
                    overviewPageLinks.forEach((x) => x.classList.toggle(HIDE_CLASS, x.dataset.parentIndex !== index));
                    menuItems.forEach((x) => x.classList.toggle(HIDE_CLASS, x.dataset.parentIndex !== index));
                    container.classList.toggle(LOADING_CLASS, !!loading[loadingKey]);
                    container.classList.toggle(CONTAINER_HIDE_CLASS, false);
                    thirdLevelGrid.classList.toggle(HIDE_CLASS, false);
                    sideContainer.classList.toggle(HIDE_CLASS, false);
                    // set defaults for mouseleave on item
                    if (sideContainerDeps) {
                        sideContainer.dataset.imageUrl = sideContainerDeps.imageUrl;
                        sideContainer.dataset.link = sideContainerDeps.link;
                    }
                    sideContainerDeps && updateSideContaier(sideContainerDeps);
                    return true;
                });
                const updateSideContaier = (settings) => {
                    const { imageUrl, link } = settings;
                    const sideContainerImage = sideContainer.querySelector(".technical-navigation-third-level-side-image");
                    if (sideContainerImage)
                        sideContainerImage.src = imageUrl;
                    const sideContainerImageLink = sideContainer.querySelector(".technical-navigation-third-level-image-side-link.technical-navigation-third-level-side-link");
                    sideContainerImageLink && sideContainerImageLink.classList.toggle(HIDE_CLASS, !imageUrl);
                    const sideContainerLinks = sideContainer.querySelectorAll(".technical-navigation-third-level-side-link");
                    sideContainerLinks.forEach((x) => (x.href = link));
                };
                const close = () => {
                    thirdLevelGrid.classList.toggle(HIDE_CLASS, true);
                    sideContainer.classList.toggle(HIDE_CLASS, true);
                    container.classList.toggle(CONTAINER_HIDE_CLASS, true);
                };
                return {
                    open,
                    close,
                };
            }
            main.CreateNavigationDesktopThirdLevel = CreateNavigationDesktopThirdLevel;
            function initNavigationDesktop(containerEl, deps) {
                const firstLevelMenuEls = eXpress.html.querySelectorAll(containerEl, ".technical-desktop-first-level-menu-item");
                const { loadDesktopMenuItemAsync } = deps;
                const loadedMenuItemsKeys = [];
                let disposable;
                const firstLevelActiveClass = "o-menu-first-level__button--active";
                const secondLevelActiveClass = "o-menu-second-level__list-item--active";
                const closeMenu = (e) => {
                    e.stopPropagation();
                    const clickedItem = e.currentTarget;
                    if (eXpress.html.getParentWithClassName(clickedItem, 'o-menu-second-level__list'))
                        return;
                    firstLevelMenuEls.forEach(el => closeFirstLevelMenuItemAndResetChildMenus(el));
                };
                const closeFirstLevelMenuItemAndResetChildMenus = (menuItem) => {
                    const buttonEL = eXpress.html.querySelector(menuItem, '.technical-level1-button', true);
                    eXpress.html.removeClass(buttonEL, firstLevelActiveClass);
                    closeAllSecondLevelMenuItemsAndResetChildMenus(menuItem);
                };
                const closeAllSecondLevelMenuItemsAndResetChildMenus = (menuItem) => {
                    const secondLevelMenuEls = eXpress.html.querySelectorAll(menuItem, '.technical-desktop-menu-second');
                    secondLevelMenuEls.forEach(secondLevelMenuEl => {
                        eXpress.html.addClass(secondLevelMenuEl, 'u-hide');
                        closeAllThirdLevelMenuItemsAndResetChildMenus(secondLevelMenuEl);
                    });
                };
                const closeAllThirdLevelMenuItemsAndResetChildMenus = (menuItem) => {
                    const allThirdLevelMenuItems = eXpress.html.querySelectorAll(menuItem, '.technical-desktop-second-level-menu-item');
                    allThirdLevelMenuItems.forEach(el => {
                        const contentEl = eXpress.html.querySelector(el, '.technical-desktop-second-level-content', false);
                        contentEl && eXpress.html.addClass(contentEl, 'u-hide');
                        eXpress.html.removeClass(el, secondLevelActiveClass);
                    });
                };
                const getOrLoadFirstLevelMenuItem = (e) => {
                    e.stopPropagation();
                    if (e.type.toLowerCase() === "mouseenter" && eXpress.utils.isTouchDevice())
                        return;
                    const menuItem = e.currentTarget;
                    const secondLevelMenuEl = eXpress.html.querySelector(menuItem, '.technical-desktop-menu-second', true);
                    const buttonEL = eXpress.html.querySelector(menuItem, '.technical-level1-button', true);
                    const closeMenuOnMouseOut = (e) => {
                        const menuItem = e.currentTarget;
                        closeFirstLevelMenuItemAndResetChildMenus(menuItem);
                    };
                    // First hide all other items
                    const allSecondLevelMenuItems = eXpress.html.querySelectorAll(containerEl, '.technical-desktop-menu-second');
                    allSecondLevelMenuItems.forEach(el => closeAllSecondLevelMenuItemsAndResetChildMenus(el));
                    // Set selected item and fetch content if needed
                    if (eXpress.html.querySelectorAll(secondLevelMenuEl, ".o-menu-second-level__list.skeleton-loading").length === 1) {
                        const itemKey = parseInt(menuItem.getAttribute("data-menu-item") || "", 10);
                        const alreadyLoaded = itemKey in loadedMenuItemsKeys;
                        if (!alreadyLoaded) {
                            loadedMenuItemsKeys[itemKey] = [];
                            eXpress.html.addClass(buttonEL, firstLevelActiveClass);
                            loadDesktopMenuItemAsync(itemKey, -1).then(res => {
                                secondLevelMenuEl.innerHTML = ""; // this removes the skeleton loading
                                secondLevelMenuEl.insertAdjacentHTML('beforeend', res);
                                window.addEventListener('resize', () => {
                                    eXpress.utils.debounce(() => {
                                        if (!secondLevelMenuEl)
                                            return;
                                        secondLevelMenuEl.style.top = Math.floor(parseFloat(window.getComputedStyle(eXpress.html.querySelector(document, '.technical-header', true)).height)) + 'px';
                                    }, 250);
                                });
                                secondLevelMenuEl.style.top = Math.floor(parseFloat(window.getComputedStyle(eXpress.html.querySelector(document, '.technical-header', true)).height)) + 'px';
                                const buttonEls = eXpress.html.querySelectorAll(secondLevelMenuEl, '.technical-third-link-item');
                                if (buttonEls.every(x => x.nodeName.toLowerCase() === 'a')) {
                                    const subMenuListEl = eXpress.html.querySelector(secondLevelMenuEl, '.o-menu-second-level__list', true);
                                    // subtract padding-left from the first level container so the left position aligns visually
                                    const firstLevelContainer = eXpress.html.querySelector(containerEl, '.technical-desktop-first-level', false)
                                        || eXpress.html.querySelector(containerEl, '.technical-navigation-first-level', false);
                                    const paddingLeft = firstLevelContainer ? parseFloat(window.getComputedStyle(firstLevelContainer).paddingLeft) || 0 : 0;
                                    subMenuListEl.style.left = (menuItem.offsetLeft - containerEl.offsetLeft - paddingLeft) + "px";
                                }
                                initSecondLevelListeners();
                                // To prevent opening the menu, when the visitor already moved to another menu item, we check the active class again
                                if (eXpress.html.hasClass(buttonEL, firstLevelActiveClass))
                                    eXpress.html.removeClass(secondLevelMenuEl, 'u-hide');
                            });
                            if (disposable && disposable.add) {
                                disposable.add([eXpress.utils.compositeDisposable(firstLevelMenuEls.map(el => eXpress.html.addEventListener(el, 'mouseleave', closeMenuOnMouseOut)))]);
                                disposable.add([eXpress.html.addEventListener(secondLevelMenuEl, 'click', closeMenu)]);
                            }
                        }
                    }
                    else {
                        if (e.type.toLowerCase() === "click" && eXpress.utils.isTouchDevice()) {
                            if (eXpress.html.hasClass(buttonEL, firstLevelActiveClass)) {
                                eXpress.html.removeClass(buttonEL, firstLevelActiveClass);
                                eXpress.html.addClass(secondLevelMenuEl, 'u-hide');
                                closeAllThirdLevelMenuItemsAndResetChildMenus(secondLevelMenuEl);
                            }
                            else {
                                eXpress.html.addClass(buttonEL, firstLevelActiveClass);
                                eXpress.html.removeClass(secondLevelMenuEl, 'u-hide');
                            }
                        }
                        else {
                            eXpress.html.addClass(buttonEL, firstLevelActiveClass);
                            eXpress.html.removeClass(secondLevelMenuEl, 'u-hide');
                        }
                    }
                };
                const initFirstLevelListeners = () => {
                    disposable = eXpress.utils.compositeDisposable(firstLevelMenuEls.map(el => eXpress.html.addEventListener(el, 'mouseenter', getOrLoadFirstLevelMenuItem)));
                    disposable && disposable.add && disposable.add([eXpress.utils.compositeDisposable(firstLevelMenuEls.map(el => eXpress.html.addEventListener(el, 'click', getOrLoadFirstLevelMenuItem)))]);
                };
                const getOrLoadSecondLevelMenuItem = (e) => {
                    e.stopPropagation();
                    if (e.type.toLowerCase() === "mouseenter" && eXpress.utils.isTouchDevice())
                        return;
                    const menuItem = e.currentTarget;
                    if (eXpress.html.hasClass(menuItem, secondLevelActiveClass))
                        return;
                    const parent = menuItem.closest(".technical-desktop-first-level-menu-item");
                    // First hide all other items
                    closeAllThirdLevelMenuItemsAndResetChildMenus(parent);
                    // Set selected item and fetch content if needed
                    eXpress.html.addClass(menuItem, secondLevelActiveClass);
                    const contentEl = eXpress.html.querySelector(menuItem, '.technical-desktop-second-level-content', false);
                    contentEl && eXpress.html.removeClass(contentEl, 'u-hide');
                    const buttonEl = eXpress.html.querySelector(menuItem, '.technical-third-link-item', true);
                    if (buttonEl.nodeName.toLowerCase() === "button") {
                        const firstLevelIndex = parseInt(parent.getAttribute("data-menu-item") || "", 10);
                        const secondLevelIndex = parseInt(menuItem.getAttribute("data-menu-item") || "", 10);
                        const alreadyLoaded = loadedMenuItemsKeys[firstLevelIndex].includes(secondLevelIndex);
                        if (!alreadyLoaded) {
                            loadedMenuItemsKeys[firstLevelIndex].push(secondLevelIndex);
                            loadDesktopMenuItemAsync(firstLevelIndex, secondLevelIndex).then(res => {
                                const contentItem = menuItem.querySelector(".technical-desktop-second-level-content");
                                if (contentItem)
                                    contentItem.innerHTML = res;
                            });
                        }
                    }
                };
                const initSecondLevelListeners = () => {
                    const secondLevelMenuEls = eXpress.html.querySelectorAll(containerEl, ".technical-desktop-second-level-menu-item");
                    if (disposable && disposable.add) {
                        disposable.add([eXpress.utils.compositeDisposable(secondLevelMenuEls.map(el => eXpress.html.addEventListener(el, 'mouseenter', getOrLoadSecondLevelMenuItem)))]);
                        disposable.add([eXpress.utils.compositeDisposable(secondLevelMenuEls.map(el => eXpress.html.addEventListener(el, 'click', getOrLoadSecondLevelMenuItem)))]);
                    }
                };
                // init handlers on load
                initFirstLevelListeners();
                const disableHoverMenuItems = () => disposable && disposable.dispose();
                return { dispose: disableHoverMenuItems };
            }
            main.initNavigationDesktop = initNavigationDesktop;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initHamburgerMenu(buttonEl, deps) {
                const openClass = "a-hamburger-menu--open";
                const { onButtonClick } = deps;
                const menuButtonComponent = main.createClickableElement(buttonEl, onButtonClick);
                return {
                    open: () => buttonEl.classList.add(openClass),
                    close: () => buttonEl.classList.remove(openClass),
                    toggle: (force) => buttonEl.classList.toggle(openClass, force),
                    dispose: () => menuButtonComponent.dispose(),
                };
            }
            main.initHamburgerMenu = initHamburgerMenu;
            function initNavigationMobile(options, deps) {
                let firstLevelMenuSelected;
                let onDocumentClickDisposable;
                let onCloseClickDisposable;
                let userContainerEl;
                let closeContainerEl;
                let languageSelectorEl;
                let firstLevelMenuEls;
                let secondLevelMenuEls;
                let thirdLevelMenuEls;
                let loaded = false;
                const { mobileMenuEl, containerEl, menuButtonEl, menuContainerEl, } = options;
                const { getMobileMenu, getIconsAsync, onOpen, onClose, } = deps;
                const contentPreLoaded = mobileMenuEl.innerHTML.replace(/^\s+|\s+$/, '') !== "";
                const onButtonClick = () => menuContainerEl.classList.contains("menu-is-open")
                    ? closeMenu()
                    : openMenu();
                const hamburgerMenuComponent = initHamburgerMenu(menuButtonEl, {
                    onButtonClick: onButtonClick,
                });
                const closeMenu = () => {
                    hamburgerMenuComponent.close();
                    menuContainerEl.classList.remove("menu-is-open");
                    // reset to first level
                    resetMenu();
                    detachDocumentClick();
                    if (onClose)
                        onClose();
                    return $.Deferred().resolve().promise();
                };
                const onCloseMenuClick = (e) => {
                    e.stopPropagation();
                    closeMenu();
                };
                const onDocumentClick = (e) => {
                    if (!e.target.closest(".technical-mobile-navigation-hamburger-menu-container, .technical-mobile-navigation-hamburger-menu-button")) {
                        closeMenu();
                    }
                };
                const attachOnDocumentClick = () => (onDocumentClickDisposable = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(document, 'click', onDocumentClick, true)
                ]));
                const detachDocumentClick = () => onDocumentClickDisposable && onDocumentClickDisposable.dispose();
                const loadIcons = (urls) => {
                    const icons = {};
                    const uniqueUrls = urls.filter((v, i) => urls.indexOf(v) === i);
                    return getIconsAsync(uniqueUrls)
                        .then(res => {
                        res.forEach(icon => (icons[icon.url] = icon.svg));
                        return icons;
                    });
                };
                const initMenuItemsAndBehavior = () => {
                    const firstLevelListEl = eXpress.html.querySelector(mobileMenuEl, ".o-navigation-mobile__first-level-navigation__button-list", true);
                    userContainerEl = eXpress.html.querySelector(mobileMenuEl, ".technical-mobile-navigation-user-container", true);
                    closeContainerEl = eXpress.html.querySelector(mobileMenuEl, ".technical-mobile-navigation-close-container", true);
                    languageSelectorEl = eXpress.html.querySelector(mobileMenuEl, ".technical-language-selector") || undefined;
                    firstLevelMenuEls = eXpress.html.querySelectorAll(mobileMenuEl, ".technical-mobile-navigation-first-level-container");
                    secondLevelMenuEls = eXpress.html.querySelectorAll(mobileMenuEl, ".technical-mobile-navigation-second-level-container");
                    thirdLevelMenuEls = eXpress.html.querySelectorAll(mobileMenuEl, ".o-navigation-mobile__third-level-navigation__button-container");
                    // set language
                    languageSelectorEl && main.initLanguageSelector(languageSelectorEl);
                    const iconButtonEls = eXpress.html.querySelectorAll(firstLevelListEl, '.technical-icon-svg')
                        .filter(el => !!el.getAttribute('data-icon-svg'));
                    if (iconButtonEls.length > 0) {
                        loadIcons(iconButtonEls.map(el => el.getAttribute('data-icon-svg')))
                            .then(res => iconButtonEls.forEach(el => {
                            const icon = res[el.getAttribute('data-icon-svg')];
                            if (icon)
                                el.insertAdjacentHTML("beforeend", icon);
                        }));
                    }
                    if (closeContainerEl)
                        attachCloseMenuClick(closeContainerEl);
                    attachFirstMenuItemClick(firstLevelMenuEls);
                };
                const loadMobileMenu = () => {
                    if (!loaded) {
                        if (!contentPreLoaded) {
                            return getMobileMenu()
                                .then(res => {
                                onOpen && onOpen();
                                loaded = true;
                                mobileMenuEl.insertAdjacentHTML('beforeend', res);
                                initMenuItemsAndBehavior();
                            });
                        }
                        else {
                            loaded = true;
                            initMenuItemsAndBehavior();
                            return $.Deferred().resolve().promise();
                        }
                    }
                    else {
                        onOpen && onOpen();
                        return $.Deferred().resolve().promise();
                    }
                };
                const openMenu = () => {
                    return loadMobileMenu()
                        // @ts-ignore
                        .then(() => {
                        // show mobile menu (add display block so height can be correctly calculated first)
                        hamburgerMenuComponent.open();
                        menuContainerEl.classList.add("menu-is-open");
                        attachOnDocumentClick();
                        const firstLevelListEl = eXpress.html.querySelector(mobileMenuEl, ".o-navigation-mobile__first-level-navigation__button-list", true);
                        eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(firstLevelListEl);
                        // Save height for later use in data attribute 'elementHeight'
                        firstLevelListEl.dataset.elementHeight = firstLevelListEl.style.height || '';
                    });
                };
                const resetMenu = () => {
                    containerEl.classList.remove("second-level-is-active");
                    containerEl.classList.remove("third-level-is-active");
                    userContainerEl.classList.remove("u-hide");
                    closeContainerEl.classList.remove("u-hide");
                    // Show first level
                    firstLevelMenuEls.forEach(firstLevelEl => {
                        firstLevelEl.classList.remove("u-hide");
                        const firstLevelMenuButtons = eXpress.html.querySelectorAll(firstLevelEl, ".o-navigation-mobile__first-level-navigation__button");
                        firstLevelMenuButtons.forEach(el => el.classList.remove("u-hide"));
                    });
                    //Hide second and third level
                    eXpress.html.querySelectorAll(containerEl, ".technical-mobile-navigation-second-level").forEach(el => {
                        if (!el.classList.contains("u-hide"))
                            el.classList.add("u-hide");
                    });
                    secondLevelMenuEls.forEach(secondLevelEl => {
                        if (!secondLevelEl.classList.contains("u-hide"))
                            secondLevelEl.classList.add("u-hide");
                        const menuSecondLevelContainerEls = eXpress.html.querySelectorAll(secondLevelEl, ".technical-mobile-navigation-container");
                        menuSecondLevelContainerEls.forEach(el => el.classList.remove("u-hide"));
                        const thirdLevelEls = eXpress.html.querySelectorAll(secondLevelEl, ".technical-mobile-navigation-third-level");
                        thirdLevelEls.forEach(thirdLevelEl => {
                            if (!thirdLevelEl.classList.contains("u-hide"))
                                thirdLevelEl.classList.add("u-hide");
                        });
                    });
                };
                const hideOtherMenuItems = (elem) => {
                    if (elem.parentNode && elem.parentNode.hasChildNodes()) {
                        [].slice.call(elem.parentNode.children)
                            .forEach(el => {
                            const elm = el;
                            if (elem !== elm) {
                                elm.classList.toggle("u-hide");
                            }
                        });
                    }
                };
                const onFirstMenuItemClick = (e) => {
                    var _a;
                    if (handleHeaderLink(e.target))
                        return;
                    const firstLevelEl = e.currentTarget;
                    const secondLevelIndex = (_a = Number(firstLevelEl.dataset.index)) !== null && _a !== void 0 ? _a : -1;
                    const secondLevelEl = eXpress.html.querySelector(firstLevelEl, '.technical-mobile-navigation-second-level', false);
                    if (!secondLevelEl)
                        return; // no second level
                    firstLevelMenuSelected = eXpress.html.querySelector(firstLevelEl, ".technical-mobile-navigation-second-level") || undefined;
                    const prevClickedEl = eXpress.html.querySelector(mobileMenuEl, ".technical-clicked", false);
                    // Values of first lvl menu (needs to be recalculated since the 'account' section isn't shown in 2nd lvl)
                    const firstLevelListEl = eXpress.html.querySelector(mobileMenuEl, ".o-navigation-mobile__first-level-navigation__button-list", true);
                    // calculateAndSetHeightOfMobileNavigationLevel(firstLevelListEl);
                    // Set height of first lvl again correct (get from data attribute elementHeight if the previously clicked element is the same as the currently clicked element, otherwise set to 100vh to calculate height of 2nd lvl menu correctly)
                    firstLevelListEl.style.height = prevClickedEl ? firstLevelListEl.dataset.elementHeight || "" : "100vh";
                    // Reset scroll position otherwise 2nd lvl can already be scrolled down:
                    firstLevelListEl.scrollTop = 0;
                    if (firstLevelMenuSelected) {
                        // Keep track of clicked element and its scrollTop
                        if (!prevClickedEl) {
                            firstLevelEl.classList.add("technical-clicked");
                            firstLevelEl.dataset.offset = firstLevelEl.offsetTop + "";
                            const parent = firstLevelEl.parentNode;
                            if (parent)
                                parent.dataset.offset = parent.offsetTop + "";
                        }
                        containerEl.classList.add("second-level-is-active");
                        containerEl.classList.remove("third-level-is-active");
                        userContainerEl.classList.toggle("u-hide");
                        closeContainerEl.classList.toggle("u-hide");
                        hideOtherMenuItems(firstLevelEl);
                        firstLevelMenuSelected.classList.toggle("u-hide");
                        const firstLevelMenuButton = eXpress.html.querySelector(firstLevelEl, ".o-navigation-mobile__first-level-navigation__button");
                        if (firstLevelMenuButton)
                            firstLevelMenuButton.classList.toggle("u-hide");
                        const secondLevelNavigationEl = eXpress.html.querySelector(firstLevelMenuSelected, ".technical-second-level");
                        if (secondLevelNavigationEl)
                            secondLevelNavigationEl.classList.remove("u-hide");
                        const secondLevelContainerEl = eXpress.html.querySelectorAll(firstLevelMenuSelected, ".technical-mobile-navigation-second-level-container");
                        secondLevelContainerEl.forEach((el) => el.classList.remove("u-hide"));
                        // Calculate height of second lvl menu (without browser bars)
                        const menuItemsSecondLvl = eXpress.html.querySelector(firstLevelMenuSelected, '.o-navigation-mobile__second-level-navigation__button-list', false);
                        if (menuItemsSecondLvl && menuItemsSecondLvl.clientHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsSecondLvl);
                        else
                            firstLevelListEl.style.height = firstLevelListEl.dataset.elementHeight || '';
                    }
                    // In case we have a clicked element bring it into view
                    if (prevClickedEl) {
                        prevClickedEl.classList.remove("technical-clicked");
                        setScrollTop(prevClickedEl);
                        if (prevClickedEl.parentNode) {
                            setScrollTop(prevClickedEl.parentNode);
                        }
                    }
                    if (!firstLevelMenuSelected)
                        return;
                    const loadSecondLevelEl = eXpress.html.querySelector(secondLevelEl, '.technical-replace-level-loaded', false);
                    if (!loadSecondLevelEl || !loadSecondLevelEl.parentElement) {
                        // Calculate height of second lvl menu (without browser bars)
                        const menuItemsSecondLvl = eXpress.html.querySelector(firstLevelMenuSelected, '.o-navigation-mobile__second-level-navigation__button-list', false);
                        if (menuItemsSecondLvl && menuItemsSecondLvl.clientHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsSecondLvl);
                        else
                            firstLevelListEl.style.height = firstLevelListEl.dataset.elementHeight || '';
                        return;
                    }
                    // load second level
                    getMobileMenu(secondLevelIndex, -1).then(res => {
                        const frag = document.createRange().createContextualFragment(res);
                        secondLevelEl.replaceChild(frag, loadSecondLevelEl);
                        const secondLevelItems = eXpress.html.querySelectorAll(firstLevelEl, ".technical-mobile-navigation-second-level-container");
                        secondLevelMenuEls = secondLevelMenuEls.concat(secondLevelItems);
                        attachSecondMenuItemClick(secondLevelItems);
                        // Calculate height of second lvl menu (without browser bars)
                        if (!firstLevelMenuSelected)
                            return;
                        const menuItemsSecondLvl = eXpress.html.querySelector(firstLevelMenuSelected, '.o-navigation-mobile__second-level-navigation__button-list', false);
                        if (menuItemsSecondLvl && menuItemsSecondLvl.clientHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsSecondLvl);
                        else
                            firstLevelListEl.style.height = firstLevelListEl.dataset.elementHeight || '';
                    });
                };
                const setScrollTop = (el) => {
                    const scrollPos = el.dataset.offset || "";
                    if (scrollPos && el.parentNode) {
                        const parent = el.parentNode;
                        parent.scrollTop = parseInt(scrollPos, 10);
                        el.dataset.offset = "";
                    }
                };
                const onSecondMenuItemClick = (e) => {
                    var _a, _b;
                    if (handleHeaderLink(e.target))
                        return;
                    e.stopPropagation();
                    const secondLevelEl = e.currentTarget;
                    const thirdLevelDivEl = eXpress.html.querySelector(secondLevelEl, '.technical-mobile-navigation-third-level', false);
                    if (!thirdLevelDivEl)
                        return; // no third level
                    // 3th level
                    const thirdLevelEl = secondLevelEl.querySelector(".technical-mobile-navigation-third-level");
                    if (thirdLevelEl) {
                        containerEl.classList.toggle("third-level-is-active");
                        thirdLevelEl.classList.toggle("u-hide");
                        hideOtherMenuItems(secondLevelEl);
                        if (firstLevelMenuSelected) {
                            const secondeLevelNavigationEl = firstLevelMenuSelected.querySelector(".technical-second-level");
                            if (secondeLevelNavigationEl)
                                secondeLevelNavigationEl.classList.toggle("u-hide");
                        }
                        const thirdLevelContainerEl = secondLevelEl.querySelector(".technical-mobile-navigation-container");
                        if (thirdLevelContainerEl)
                            thirdLevelContainerEl.classList.toggle("u-hide");
                        const menuItemsThirdLvl = eXpress.html.querySelector(secondLevelEl, '.o-navigation-mobile__third-level-navigation__button-list', false);
                        // Calculate height of third lvl menu (without browser bars)
                        if (menuItemsThirdLvl && menuItemsThirdLvl.offsetHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsThirdLvl);
                    }
                    const loadThridLevelEl = eXpress.html.querySelector(thirdLevelDivEl, '.technical-replace-level-loaded', false);
                    if (!loadThridLevelEl || !loadThridLevelEl.parentElement) {
                        const menuItemsThirdLvl = eXpress.html.querySelector(secondLevelEl, '.o-navigation-mobile__third-level-navigation__button-list', false);
                        // Calculate height of third lvl menu (without browser bars)
                        if (menuItemsThirdLvl && menuItemsThirdLvl.offsetHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsThirdLvl);
                        return;
                    }
                    // get from api
                    const secondLevelIndex = (_a = Number(secondLevelEl.closest('.technical-mobile-navigation-first-level-container').dataset.index)) !== null && _a !== void 0 ? _a : -1;
                    const thirdLevelIndex = (_b = Number(secondLevelEl.dataset.index)) !== null && _b !== void 0 ? _b : -1;
                    getMobileMenu(secondLevelIndex, thirdLevelIndex).then(res => {
                        const frag = document.createRange().createContextualFragment(res);
                        thirdLevelDivEl.replaceChild(frag, loadThridLevelEl); // sub level of level
                        const thirdLevelItems = eXpress.html.querySelectorAll(secondLevelEl, ".o-navigation-mobile__third-level-navigation__button-container");
                        thirdLevelMenuEls = thirdLevelMenuEls.concat(thirdLevelItems);
                        attachThirdMenuItemClick(thirdLevelItems);
                        const menuItemsThirdLvl = eXpress.html.querySelector(secondLevelEl, '.o-navigation-mobile__third-level-navigation__button-list', false);
                        // Calculate height of third lvl menu (without browser bars)
                        if (menuItemsThirdLvl && menuItemsThirdLvl.offsetHeight > 0)
                            eXpress.utils.calculateAndSetHeightOfMobileNavigationLevel(menuItemsThirdLvl);
                    });
                };
                const onThirdMenuItemClick = (e) => {
                    e.stopPropagation();
                };
                const handleHeaderLink = (evTarget) => {
                    if (evTarget) {
                        const target = evTarget;
                        if (target.nodeName.toLowerCase() === "a" || (target.parentNode && target.parentNode.nodeName.toLowerCase() === "a")) {
                            return true;
                        }
                    }
                    return false;
                };
                const attachCloseMenuClick = (closeContainerEl) => {
                    const closeButtonEl = eXpress.html.querySelector(closeContainerEl, ".m-navigation-overlay__close-icon");
                    if (closeButtonEl) {
                        onCloseClickDisposable = eXpress.utils.compositeDisposable([eXpress.html.addEventListener(closeContainerEl, "click", onCloseMenuClick)]);
                    }
                };
                const detachCloseMenuClick = () => onCloseClickDisposable && onCloseClickDisposable.dispose();
                const attachFirstMenuItemClick = (firstLevelMenuEls) => {
                    firstLevelMenuEls.forEach(e => eXpress.html.addEventListener(e, "click", onFirstMenuItemClick));
                };
                const attachSecondMenuItemClick = (secondLevelMenuEls) => {
                    secondLevelMenuEls.forEach(e => eXpress.html.addEventListener(e, "click", onSecondMenuItemClick));
                };
                const attachThirdMenuItemClick = (thirdLevelMenuEls) => {
                    thirdLevelMenuEls.forEach(e => eXpress.html.addEventListener(e, "click", onThirdMenuItemClick));
                };
                const deInit = () => {
                    dispose();
                    closeMenu();
                };
                // remove all handlers
                const dispose = () => {
                    hamburgerMenuComponent.dispose();
                    detachCloseMenuClick();
                    detachDocumentClick();
                    firstLevelMenuEls.forEach(e => e.removeEventListener("click", onFirstMenuItemClick));
                    secondLevelMenuEls.forEach(e => e.removeEventListener("click", onSecondMenuItemClick));
                    thirdLevelMenuEls.forEach(e => e.removeEventListener("click", onThirdMenuItemClick));
                };
                return {
                    deInit
                };
            }
            main.initNavigationMobile = initNavigationMobile;
            function initNavigationMobileNew(placeholder, buttonEl, deps) {
                let onDocumentClickDisposable;
                let languageSelector;
                const menuCache = [];
                const { getMobileMenu, getIconsAsync, onOpen, onClose } = deps;
                const firstLevelDisposables = eXpress.utils.compositeDisposable([]);
                const secondLevelDisposables = eXpress.utils.compositeDisposable([]);
                const thirdLevelDisposables = eXpress.utils.compositeDisposable([]);
                let currentSecondLevelIndex = -1;
                let currentThirdLevelIndex = -1;
                const htmlEl = eXpress.html.querySelector(document, "html", true);
                const currentScope = window.context.scope;
                const bodyEl = eXpress.html.querySelector(document, "body", true);
                const onButtonClick = () => (placeholder.classList.contains("menu-is-open") ? closeMenu() : openMenu());
                const hamburgerMenuComponent = initHamburgerMenu(buttonEl, {
                    onButtonClick: onButtonClick,
                });
                const onDocumentClick = (e) => {
                    if (!e.target.closest("#technical-mobile-menu, .technical-mobile-navigation-hamburger-menu-button")) {
                        closeMenu();
                    }
                };
                const attachOnDocumentClick = () => (onDocumentClickDisposable = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(document, 'click', onDocumentClick, true)
                ]));
                const detachDocumentClick = () => onDocumentClickDisposable && onDocumentClickDisposable.dispose();
                const closeMenu = () => {
                    eXpress.html.removeClass(htmlEl, "has-open-dialog u-no-scroll");
                    eXpress.html.removeClass(bodyEl, "u-no-scroll");
                    setCloseClasses();
                    detachDocumentClick();
                    if (onClose)
                        onClose();
                    currentSecondLevelIndex = -1;
                    currentThirdLevelIndex = -1;
                    disposeMenuDisposables();
                    return $.Deferred().resolve().promise();
                };
                const setCloseClasses = () => {
                    hamburgerMenuComponent.close();
                    placeholder.classList.remove("menu-is-open");
                    placeholder.classList.add("u-hide");
                };
                const loadIcons = (urls) => __awaiter(this, void 0, void 0, function* () {
                    const icons = {};
                    const uniqueUrls = urls.filter((v, i) => urls.indexOf(v) === i);
                    const res = yield getIconsAsync(uniqueUrls);
                    res.forEach((icon) => (icons[icon.url] = icon.svg));
                    return icons;
                });
                const attachFirstLevelMenuItemClick = (firstLevelMenuEls) => {
                    firstLevelMenuEls.forEach((e) => {
                        if (firstLevelDisposables && firstLevelDisposables.add) {
                            firstLevelDisposables.add([eXpress.html.addEventListener(e, "click", (e) => {
                                    const clickedEl = e.currentTarget;
                                    currentSecondLevelIndex = parseInt(clickedEl.dataset.index || "-1", 10);
                                    firstLevelDisposables.dispose();
                                    onSubLevelMenuItemClick(e).then((r) => initSecondLevelMenuItemsAndBehavior(r));
                                })]);
                        }
                    });
                };
                const attachSecondLevelMenuItemClick = (secondLevelMenuEls) => {
                    secondLevelMenuEls.forEach((e) => {
                        if (secondLevelDisposables && secondLevelDisposables.add) {
                            secondLevelDisposables.add([
                                eXpress.html.addEventListener(e, "click", (e) => {
                                    const clickedEl = e.currentTarget;
                                    currentThirdLevelIndex = parseInt(clickedEl.dataset.index || "-1", 10);
                                    secondLevelDisposables.dispose();
                                    onSubLevelMenuItemClick(e).then((r) => initThirdLevelMenuItemsAndBehavior(r));
                                })
                            ]);
                        }
                    });
                };
                const onSubLevelMenuItemClick = (e) => __awaiter(this, void 0, void 0, function* () {
                    const cachedMenu = getCachedMenu(currentSecondLevelIndex, currentThirdLevelIndex);
                    if (cachedMenu) {
                        placeholder.innerHTML = cachedMenu.content;
                        return placeholder;
                    }
                    else {
                        const res = yield getMobileMenu(currentSecondLevelIndex, currentThirdLevelIndex);
                        const newMenuEl = eXpress.html.htmlToElement(res);
                        placeholder.innerHTML = newMenuEl.innerHTML;
                        return placeholder;
                    }
                });
                const initSubLevelMenuItemsAndBehavior = (menuEl, options) => {
                    const { onBack, disposables, initPrevLevelMenu, attachMenuItemClick } = options;
                    const topSecondaryEl = eXpress.html.querySelector(menuEl, ".technical-navigation-secondary-top", true);
                    const backButtonEl = eXpress.html.querySelector(topSecondaryEl, "button", true);
                    if (backButtonEl) {
                        if (disposables && disposables.add) {
                            disposables.add([eXpress.html.addEventListener(backButtonEl, "click", () => {
                                    onBack();
                                    const cachedMenu = getCachedMenu(currentSecondLevelIndex, currentThirdLevelIndex);
                                    if (cachedMenu) {
                                        placeholder.innerHTML = cachedMenu.content;
                                        initPrevLevelMenu(placeholder);
                                    }
                                })]);
                        }
                    }
                    loadIconsFromCmsAndCache(menuEl);
                    if (attachMenuItemClick) {
                        const menuItemEls = eXpress.html.querySelectorAll(menuEl, "button.technical-navigation-action");
                        if (menuItemEls && menuItemEls.length > 0) {
                            attachMenuItemClick(menuItemEls);
                        }
                    }
                    setMaxHeightOnListElement(placeholder);
                };
                const initSecondLevelMenuItemsAndBehavior = (menuEl) => {
                    initSubLevelMenuItemsAndBehavior(menuEl, {
                        level: "second",
                        onBack: () => {
                            currentSecondLevelIndex = -1;
                        },
                        disposables: secondLevelDisposables,
                        initPrevLevelMenu: initMenuItemsAndBehavior,
                        attachMenuItemClick: attachSecondLevelMenuItemClick,
                    });
                };
                const initThirdLevelMenuItemsAndBehavior = (menuEl) => {
                    initSubLevelMenuItemsAndBehavior(menuEl, {
                        level: "third",
                        onBack: () => {
                            currentThirdLevelIndex = -1;
                        },
                        disposables: thirdLevelDisposables,
                        initPrevLevelMenu: initSecondLevelMenuItemsAndBehavior,
                    });
                };
                const setMaxHeightOnListElement = (menuEl) => {
                    const topEl = eXpress.html.querySelector(menuEl, ".technical-navigation-top", true);
                    const navigationListEl = eXpress.html.querySelector(menuEl, ".technical-navigation-list", true);
                    const topElHeight = eXpress.html.getHeightWithMargins(topEl);
                    navigationListEl.style.maxHeight = "calc(100% - " + topElHeight + "px)";
                };
                const initMenuItemsAndBehavior = (menuEl) => {
                    if (languageSelector)
                        languageSelector.dispose();
                    const languageSelectorEl = eXpress.html.querySelector(menuEl, ".technical-language-selector");
                    if (languageSelectorEl) {
                        languageSelector = main.initLanguageSelector(languageSelectorEl);
                    }
                    loadIconsFromCmsAndCache(menuEl);
                    const menuItemEls = eXpress.html.querySelectorAll(menuEl, "button.technical-navigation-action");
                    menuItemEls && attachFirstLevelMenuItemClick(menuItemEls);
                };
                const loadMobileMenu = () => {
                    const cachedMenu = getCachedMenu(currentSecondLevelIndex, currentThirdLevelIndex);
                    if (cachedMenu) {
                        placeholder.innerHTML = cachedMenu.content;
                        initMenuItemsAndBehavior(placeholder);
                        onOpen && onOpen();
                        return $.Deferred().resolve().promise();
                    }
                    else {
                        return getMobileMenu().then((res) => {
                            const newMenuEl = eXpress.html.htmlToElement(res);
                            placeholder.innerHTML = newMenuEl.innerHTML;
                            initMenuItemsAndBehavior(placeholder);
                            onOpen && onOpen();
                        });
                    }
                };
                const loadIconsFromCmsAndCache = (menuEl) => {
                    const iconButtonEls = eXpress.html.querySelectorAll(menuEl, ".technical-icon").filter((el) => {
                        if (!el.getAttribute("data-icon-svg"))
                            return false;
                        const iconFileEl = eXpress.html.querySelector(el, ".technical-icon-file");
                        if (!iconFileEl)
                            return false;
                        const svgAlreadyLoaded = eXpress.html.querySelector(iconFileEl, "svg");
                        return !svgAlreadyLoaded;
                    });
                    if (iconButtonEls.length > 0) {
                        loadIcons(iconButtonEls.map((el) => el.getAttribute("data-icon-svg"))).then((res) => {
                            iconButtonEls.forEach((el) => {
                                const icon = res[el.getAttribute("data-icon-svg")];
                                if (icon) {
                                    const iconFile = eXpress.html.querySelector(el, ".technical-icon-file");
                                    iconFile && iconFile.insertAdjacentHTML("beforeend", icon);
                                }
                            });
                            // Once icons are loaded we can save the menu in cache so next time it can be directly retrieved from there without needing to load icons again
                            updateCachedMenu(currentSecondLevelIndex, currentThirdLevelIndex, menuEl.innerHTML);
                        });
                    }
                    else {
                        // Also cache the menu in case there are no icons to load so next time it can be directly retrieved from cache
                        updateCachedMenu(currentSecondLevelIndex, currentThirdLevelIndex, menuEl.innerHTML);
                    }
                };
                const updateCachedMenu = (secondLevelIndex, thirdLevelIndex, content) => {
                    if (eXpress.utils.isLocalStorageSupported()) {
                        const localStorageCache = eXpress.utils.getLocalStorageItem("mobileMenuCache", currentScope) || [];
                        const existingCacheIndex = localStorageCache.findIndex((m) => m.secondLevelIndex === secondLevelIndex && m.thirdLevelIndex === thirdLevelIndex);
                        if (existingCacheIndex !== -1) {
                            localStorageCache[existingCacheIndex].content = content;
                        }
                        else {
                            localStorageCache.push({ secondLevelIndex, thirdLevelIndex, content });
                        }
                        const expiryDate = new Date();
                        expiryDate.setDate(expiryDate.getDate() + 1); // cache expires in 1 day
                        eXpress.utils.setLocalStorageItem("mobileMenuCache", localStorageCache, currentScope, expiryDate);
                    }
                    else {
                        menuCache.push({
                            secondLevelIndex: currentSecondLevelIndex,
                            thirdLevelIndex: currentThirdLevelIndex,
                            content: content,
                        });
                    }
                };
                const getCachedMenu = (secondLevelIndex, thirdLevelIndex) => {
                    if (eXpress.utils.isLocalStorageSupported()) {
                        const localStorageCache = eXpress.utils.getLocalStorageItem("mobileMenuCache", currentScope) || [];
                        if (!localStorageCache || localStorageCache.length === 0)
                            return undefined;
                        return localStorageCache.find((m) => m.secondLevelIndex === secondLevelIndex && m.thirdLevelIndex === thirdLevelIndex);
                    }
                    return menuCache.find((m) => m.secondLevelIndex === currentSecondLevelIndex && m.thirdLevelIndex === currentThirdLevelIndex);
                };
                const openMenu = () => {
                    return loadMobileMenu().then((res) => {
                        eXpress.html.addClass(htmlEl, "has-open-dialog u-no-scroll");
                        eXpress.html.addClass(bodyEl, "u-no-scroll");
                        hamburgerMenuComponent.open();
                        placeholder.classList.add("menu-is-open");
                        placeholder.classList.remove("u-hide");
                        attachOnDocumentClick();
                        setMaxHeightOnListElement(placeholder);
                    });
                };
                const deInit = () => {
                    dispose();
                    closeMenu();
                };
                const disposeMenuDisposables = () => {
                    firstLevelDisposables && firstLevelDisposables.dispose();
                    secondLevelDisposables && secondLevelDisposables.dispose();
                    thirdLevelDisposables && thirdLevelDisposables.dispose();
                };
                // remove all handlers
                const dispose = () => {
                    hamburgerMenuComponent.dispose();
                    languageSelector && languageSelector.deInit();
                    disposeMenuDisposables();
                    detachDocumentClick();
                };
                return {
                    deInit,
                    setCloseClasses,
                };
            }
            main.initNavigationMobileNew = initNavigationMobileNew;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createNewsletterSubscribe(containerEl, deps) {
                const formEl = eXpress.html.querySelector(containerEl, 'form', true);
                const emailEl = eXpress.html.querySelector(formEl, '.technical-subscribe-email', true);
                const emptyGuid = '00000000-0000-0000-0000-000000000000';
                const appId = containerEl.dataset.appid || emptyGuid;
                const posId = containerEl.dataset.posid || emptyGuid;
                const lang = containerEl.dataset.lang || "";
                const email = eXpress.utils.getCookie('LastUsedEmail');
                if (email)
                    emailEl.value = email;
                const { subscribeAsync } = deps;
                let source = formEl.getAttribute("source") || formEl.getAttribute("data-source") || undefined;
                !source && (source = emailEl.dataset.sourceid || (formEl.getAttribute("data-source") || undefined));
                const subscribeForm = components.main.initForm(formEl, {
                    onSubmitForm: () => {
                        return subscribeAsync(emailEl.value, appId, posId, lang, source)
                            .then(() => {
                            eXpress.html.addClass(containerEl, "m-newsletter--success");
                            eXpress.html.addClass(formEl, 'm-newsletter__form');
                        }, (e) => {
                            eXpress.html.removeClass(containerEl, "m-newsletter--success");
                            eXpress.html.removeClass(formEl, 'm-newsletter__form');
                        });
                    },
                    buttonSelector: ".technical-subscribe-button",
                    submitOnEnter: true
                });
                return { dispose: subscribeForm.dispose };
            }
            main.createNewsletterSubscribe = createNewsletterSubscribe;
            function createNewsletterUnsubscribe(containerEl, deps) {
                const formEl = eXpress.html.querySelector(containerEl, 'form', true);
                const successMessageEl = eXpress.html.querySelector(containerEl, '.technical-success-message', false);
                const errorMessageEl = eXpress.html.querySelector(containerEl, '.technical-error-message', false);
                const emailEl = eXpress.html.querySelector(formEl, '.technical-unsubscribe-mail', false);
                const checkBoxEl = eXpress.html.querySelector(formEl, '#newsletter', false);
                const { toggleSubscribeAsync } = deps;
                const emptyGuid = '00000000-0000-0000-0000-000000000000';
                const appId = containerEl.dataset.appid || emptyGuid;
                const posId = containerEl.dataset.posid || emptyGuid;
                const lang = containerEl.dataset.lang || window.context.language;
                const email = eXpress.utils.getCookie('LastUsedEmail');
                if (email && emailEl)
                    emailEl.value = email;
                const showSuccessMessage = () => {
                    successMessageEl && eXpress.html.removeClass(successMessageEl, "u-hide");
                    errorMessageEl && eXpress.html.addClass(errorMessageEl, "u-hide");
                    eXpress.html.hide(formEl);
                    eXpress.html.addClass(containerEl, "m-newsletter--success");
                };
                const showErrorMessage = () => {
                    successMessageEl && eXpress.html.addClass(successMessageEl, "u-hide");
                    errorMessageEl && eXpress.html.removeClass(errorMessageEl, "u-hide");
                    eXpress.html.show(formEl);
                };
                emailEl && emailEl.setAttribute('required', 'required');
                if (checkBoxEl)
                    checkBoxEl.setAttribute('required', 'required');
                const unsubscribeForm = components.main.initForm(formEl, {
                    onSubmitForm: () => {
                        return toggleSubscribeAsync(eXpress.utils.getParameter("personid"), emailEl ? emailEl.value : '', appId, posId, lang, 'NewsletterUnsubscribe', false, false)
                            .then(_ => showSuccessMessage())
                            .catch(_ => showErrorMessage());
                    },
                    buttonSelector: ".technical-unsubscribe-button"
                });
                return { dispose: unsubscribeForm.dispose };
            }
            main.createNewsletterUnsubscribe = createNewsletterUnsubscribe;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createNotificationTile(containerEl, markNotificationAsRead) {
                const statusEl = eXpress.html.querySelector(containerEl, ".m-notification-tile__read-status", true);
                const checkBoxEl = eXpress.html.querySelector(statusEl, ".a-form-input__input", true);
                const linkEl = eXpress.html.querySelector(containerEl, ".m-notification-tile__text__link", false);
                const remove = () => eXpress.html.remove(containerEl);
                const returnElements = [];
                const onTileClick = (e) => {
                    e.preventDefault();
                    checkBoxEl.disabled = true;
                    checkBoxEl.removeEventListener('click', onTileClick);
                    markNotificationAsRead(checkBoxEl.value)
                        .then(() => containerEl.classList.add("o-notifications-center__notification-tile--removed"))
                        .then(() => remove());
                };
                checkBoxEl.addEventListener('click', onTileClick);
                linkEl && linkEl.addEventListener('click', () => {
                    const orderNumber = linkEl.dataset.ordernumber || '';
                    const pvc = linkEl.dataset.sku || '';
                    const orderStatus = linkEl.dataset.orderstatus || '';
                    eXpress.analytics.trackOrderStatusEvent("ClickOnOrderItemNotificationLink", { orderNumber: orderNumber, pvc: pvc, orderStatus: orderStatus });
                });
                if (linkEl)
                    returnElements.push(linkEl);
                returnElements.push(checkBoxEl);
                return returnElements;
            }
            main.createNotificationTile = createNotificationTile;
            function createNotificationCenter(containerEl, deps) {
                let onDocumentClickDisposable;
                let onMarkedAllAsReadDisposable;
                let keyboardNavigatorDisposables;
                const domParser = new DOMParser();
                let loaded = false;
                const { getNotifications, isMobile, markNotificationsAsRead, onClose, onOpen } = deps;
                const buttonEl = eXpress.html.querySelector(containerEl, '.o-icon-navigation__notifications-center__icon', true);
                const notificationBellCountEl = eXpress.html.querySelector(buttonEl, '.o-icon-navigation__count ', true);
                const menuEl = eXpress.html.querySelector(containerEl, '.o-icon-navigation__notifications-center-menu', true);
                const overLayEl = eXpress.html.querySelector(menuEl, '.technical-notification-center-overlay', true);
                const contentEl = eXpress.html.querySelector(overLayEl, '.m-navigation-overlay__content', true);
                const closeButtonEl = eXpress.html.querySelector(overLayEl, '.m-navigation-overlay__close-container', true);
                let markAllAsReadButton;
                const setOverLayClass = () => {
                    const mobile = isMobile();
                    overLayEl.classList.remove(...["m-navigation-overlay__mobile-view", "m-navigation-overlay__desktop-view"]);
                    overLayEl.classList.add(mobile ? "m-navigation-overlay__mobile-view" : "m-navigation-overlay__desktop-view");
                };
                const setNotificationCount = (amount, markAllAsReadButton) => {
                    if (amount > 0) {
                        notificationBellCountEl.innerHTML = amount.toString();
                        if (markAllAsReadButton)
                            markAllAsReadButton.innerHTML += `(${amount})`;
                        eXpress.html.show(notificationBellCountEl);
                    }
                    else {
                        notificationBellCountEl.innerHTML = "";
                        eXpress.html.hide(notificationBellCountEl);
                    }
                };
                const getTiles = () => eXpress.html.querySelectorAll(contentEl, '.m-notification-tile');
                const onMarkedAsReadSingle = (ids) => markNotificationsAsRead(ids.split(';'))
                    .then(() => loadNotifications(true));
                const onMarkedAllAsRead = () => {
                    if (markAllAsReadButton) {
                        markAllAsReadButton.disabled = true;
                        markAllAsReadButton.classList.add("a-button--disabled");
                    }
                    detachMarkAllAsReadClick();
                    const ids = getTiles()
                        .map(el => eXpress.html.querySelector(el, '.a-form-input__input', true)
                        .value.split(";"))
                        .reduce((a, b) => a.concat(b), []);
                    // only execute if there are items to remove
                    if (ids && ids.length > 0) {
                        return markNotificationsAsRead(ids)
                            .then(res => {
                            if (res)
                                loadNotifications(true);
                        });
                    }
                };
                const loadNotifications = (reload = false) => {
                    if (loaded && !reload)
                        return $.Deferred().resolve().promise();
                    return getNotifications()
                        .then(res => {
                        if (res) {
                            const parsed = domParser.parseFromString(res, "text/html").documentElement;
                            const notificationCenterEl = eXpress.html.querySelector(parsed, ".o-notifications-center__container", true);
                            contentEl.innerHTML = "";
                            contentEl.insertAdjacentElement('beforeend', notificationCenterEl);
                            markAllAsReadButton = eXpress.html.querySelector(contentEl, '.o-notifications-center__mark-as-read', true);
                            const tiles = getTiles();
                            const dropdownItemEls = [];
                            if (tiles.length > 0) {
                                markAllAsReadButton.classList.remove("a-button--disabled");
                                tiles.forEach(el => dropdownItemEls.push(...createNotificationTile(el, onMarkedAsReadSingle)));
                                attachMarkAllAsReadClick(markAllAsReadButton);
                            }
                            if (tiles.length === 0) {
                                markAllAsReadButton.classList.add("a-button--disabled");
                            }
                            setNotificationCount(tiles.length);
                            if (!isMobile()) {
                                keyboardNavigatorDisposables && keyboardNavigatorDisposables.dispose();
                                keyboardNavigatorDisposables = eXpress.utils.compositeDisposable([
                                    main.createDropDownKeyboardNavigator(containerEl, {
                                        onEnter: onButtonClick,
                                        onEscape: onCloseIconClick,
                                        onBeforeArrowDown: () => {
                                            if (!menuEl.classList.contains("menu-is-open"))
                                                openMenu();
                                        },
                                        dropdownItemEls: dropdownItemEls,
                                    }),
                                ]);
                            }
                            loaded = true;
                        }
                    });
                };
                const onNotificationCenterOpen = () => {
                    setOverLayClass();
                    return loadNotifications();
                };
                const closeMenu = () => {
                    menuEl.classList.remove("menu-is-open");
                    detachDocumentClick();
                    onClose && onClose();
                    return $.Deferred().resolve().promise();
                };
                const openMenu = () => {
                    eXpress.analytics.trackOrderStatusEvent("ClickOnNotificationIcon", {});
                    return onNotificationCenterOpen()
                        // @ts-ignore
                        .then(() => {
                        onOpen && onOpen();
                        attachOnDocumentClick();
                        menuEl.classList.add("menu-is-open");
                    });
                };
                const onCloseIconClick = (e) => {
                    e.stopPropagation();
                    closeMenu();
                };
                const onButtonClick = () => {
                    return menuEl.classList.contains("menu-is-open")
                        ? closeMenu()
                        : openMenu();
                };
                const onDocumentClick = (e) => {
                    if (!e.target.closest(".o-icon-navigation__notifications-center-menu, .o-icon-navigation__notifications-center__icon")) {
                        closeMenu();
                    }
                };
                const attachOnDocumentClick = () => (onDocumentClickDisposable = eXpress.html.addEventListener(document, 'click', onDocumentClick, true));
                const detachDocumentClick = () => onDocumentClickDisposable && onDocumentClickDisposable.dispose();
                const attachMarkAllAsReadClick = (buttonEl) => (onMarkedAllAsReadDisposable = eXpress.html.addEventListener(buttonEl, 'click', onMarkedAllAsRead));
                const detachMarkAllAsReadClick = () => onMarkedAllAsReadDisposable && onMarkedAllAsReadDisposable.dispose();
                // init component
                const button = main.createClickableElement(buttonEl, onButtonClick);
                const eventDisposables = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(closeButtonEl, 'click', onCloseIconClick),
                    eXpress.html.addEventListener(window, 'resize', setOverLayClass),
                ]);
                if (!isMobile()) {
                    keyboardNavigatorDisposables = eXpress.utils.compositeDisposable([
                        main.createDropDownKeyboardNavigator(containerEl, {
                            onEnter: onButtonClick,
                            onEscape: onCloseIconClick,
                            onBeforeArrowDown: () => {
                                if (!menuEl.classList.contains("menu-is-open"))
                                    openMenu();
                            },
                            dropdownItemEls: [],
                        }),
                    ]);
                }
                return {
                    dispose: () => {
                        eventDisposables.dispose();
                        button.dispose();
                        detachDocumentClick();
                        detachMarkAllAsReadClick();
                        closeMenu();
                    }
                };
            }
            main.createNotificationCenter = createNotificationCenter;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            let PageLogStyle;
            (function (PageLogStyle) {
                PageLogStyle[PageLogStyle["Error"] = 0] = "Error";
                PageLogStyle[PageLogStyle["WarningBlue"] = 1] = "WarningBlue";
                PageLogStyle[PageLogStyle["WarningOrange"] = 2] = "WarningOrange";
                PageLogStyle[PageLogStyle["Success"] = 3] = "Success";
            })(PageLogStyle = main.PageLogStyle || (main.PageLogStyle = {}));
            function createPageLog(containerEl) {
                const iconEl = eXpress.html.querySelector(containerEl, '.technical-top-message-icon', true);
                const descriptionEl = eXpress.html.querySelector(containerEl, '.technical-top-message-description', true);
                const getClassesByPrefix = (el, prefix) => {
                    const classes = [].slice.call(el.classList);
                    return classes.filter(c => c.indexOf(prefix) > -1);
                };
                const LOG_PREFIX = "m-page-log--";
                const ICON_BG_CIRCLE_PREFIX = "v2-a-icon--background-circle-";
                const getLogIconAndType = (logStyle) => {
                    switch (logStyle) {
                        case PageLogStyle.Error:
                            return {
                                type: "m-page-log--error",
                                iconBackgroundCircle: ICON_BG_CIRCLE_PREFIX + "red",
                                icon: "/svg/close-symbol.svg#close-symbol",
                                iconTestId: "close-symbol"
                            };
                        case PageLogStyle.Success:
                            return {
                                type: "m-page-log--validation",
                                iconBackgroundCircle: ICON_BG_CIRCLE_PREFIX + "green",
                                icon: "/svg/checkmark-symbol.svg#checkmark-symbol",
                                iconTestId: "checkmark-symbol"
                            };
                        case PageLogStyle.WarningBlue:
                            return {
                                type: "m-page-log--info-blue",
                                iconBackgroundCircle: ICON_BG_CIRCLE_PREFIX + "blue",
                                icon: "/svg/info-symbol.svg#info-symbol",
                                iconTestId: "info-symbol"
                            };
                        case PageLogStyle.WarningOrange:
                            return {
                                type: "m-page-log--info-orange",
                                iconBackgroundCircle: ICON_BG_CIRCLE_PREFIX + "orange",
                                icon: "/svg/info-symbol.svg#info-symbol",
                                iconTestId: "info-symbol"
                            };
                        default:
                            return {
                                type: "",
                                iconBackgroundCircle: "",
                                icon: "",
                                iconTestId: ""
                            };
                    }
                };
                const show = () => containerEl.classList.remove("u-hide");
                const hide = () => containerEl.classList.add("u-hide");
                const scrollTo = () => window.scrollTo({ top: getOffsetTop(containerEl), behavior: 'smooth' });
                const getOffsetTop = (offsetElemet) => {
                    let offsetTop = 0;
                    let elem = offsetElemet;
                    do {
                        if (elem.offsetTop > 0) {
                            offsetTop += elem.offsetTop;
                        }
                        elem = elem.offsetParent;
                    } while (elem);
                    return offsetTop;
                };
                const updateMessageAndStyle = (logStyle, description, overrideScrollTo = false) => {
                    const disableScroll = description === descriptionEl.innerHTML;
                    containerEl.classList.remove(...getClassesByPrefix(containerEl, LOG_PREFIX));
                    iconEl.classList.remove(...getClassesByPrefix(iconEl, ICON_BG_CIRCLE_PREFIX));
                    const { type, iconBackgroundCircle, icon, iconTestId } = getLogIconAndType(logStyle);
                    containerEl.classList.add(type);
                    iconEl.classList.add(iconBackgroundCircle);
                    iconEl.dataset.test = iconTestId;
                    const useEl = eXpress.html.querySelector(iconEl, "use", true);
                    if (useEl.getAttribute("href") !== icon)
                        useEl.setAttribute("href", icon);
                    descriptionEl.innerHTML = description;
                    show();
                    if (!disableScroll || overrideScrollTo)
                        scrollTo();
                };
                return {
                    updateMessageAndStyle,
                    hide,
                    scrollTo
                };
            }
            main.createPageLog = createPageLog;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            window.addEventListener('load', () => {
                const scrollToTopEl = eXpress.html.querySelector(document, ".technical-scroll-to-top", false);
                if (!scrollToTopEl)
                    return;
                const progressPathEl = scrollToTopEl && eXpress.html.querySelector(scrollToTopEl, ".technical-progress-path", true);
                const init = () => {
                    let pathLength = 0;
                    let ticking = false;
                    const wobblerEl = eXpress.html.querySelector(document, ".technical-wobbler", false);
                    const stickyCtaButtonEl = eXpress.html.querySelector(document, ".technical-mobile-cta-button", false);
                    const footerEl = eXpress.html.querySelector(document, "footer", false);
                    if (wobblerEl && stickyCtaButtonEl && eXpress.html.isElementVisible(stickyCtaButtonEl)) {
                        scrollToTopEl.classList.add("m-scroll-to-top--has-wobbler--has-sticky-button");
                    }
                    else {
                        if (wobblerEl)
                            scrollToTopEl.classList.add("m-scroll-to-top--has-wobbler");
                        if (stickyCtaButtonEl && eXpress.html.isElementVisible(stickyCtaButtonEl))
                            scrollToTopEl.classList.add("m-scroll-to-top--has-sticky-button");
                    }
                    pathLength = progressPathEl.getTotalLength(); // compute full circle length
                    progressPathEl.style.strokeDasharray = `${pathLength} ${pathLength}`; // set dash pattern
                    progressPathEl.style.strokeDashoffset = pathLength + "";
                    const updateProgress = () => {
                        const scroll = window.scrollY; // current vertical scroll offset
                        const height = document.documentElement.scrollHeight - window.innerHeight; // total scrollable area
                        const progress = pathLength - (scroll * pathLength) / height; // proportional progress value
                        progressPathEl.style.strokeDashoffset = progress + ""; // update the circle
                    };
                    function handleScroll() {
                        if (!ticking) {
                            window.requestAnimationFrame(() => {
                                updateProgress();
                                scrollToTopEl && scrollToTopEl.classList.toggle("m-scroll-to-top--active-progress", window.scrollY > 50);
                                ticking = false;
                            });
                            ticking = true;
                        }
                    }
                    const isIOS = () => {
                        const iosQuirkPresent = () => {
                            const audio = new Audio();
                            audio.volume = 0.5;
                            return audio.volume === 1; // volume cannot be changed from "1" on iOS 12 and below
                        };
                        const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
                        const isAppleDevice = navigator.userAgent.indexOf("Macintosh") !== 0;
                        const isTouchScreen = navigator.maxTouchPoints >= 1; // true for iOS 13
                        return isIOS || (isAppleDevice && (isTouchScreen || iosQuirkPresent()));
                    };
                    const setBottomStyle = () => {
                        if (stickyCtaButtonEl && eXpress.html.isElementVisible(stickyCtaButtonEl)) {
                            if (footerEl)
                                footerEl.style.marginBottom = 10 + stickyCtaButtonEl.clientHeight + "px";
                            scrollToTopEl.style.bottom =
                                10 +
                                    stickyCtaButtonEl.clientHeight +
                                    (stickyCtaButtonEl.parentElement
                                        ? parseFloat(window.getComputedStyle(stickyCtaButtonEl.parentElement, null).getPropertyValue("padding-bottom"))
                                        : 0) +
                                    "px";
                        }
                        else {
                            scrollToTopEl.style.bottom = "";
                            if (footerEl)
                                footerEl.style.marginBottom = "";
                        }
                    };
                    const onResize = () => {
                        if (!stickyCtaButtonEl)
                            return;
                        if (eXpress.html.isElementVisible(stickyCtaButtonEl)) {
                            if (wobblerEl)
                                scrollToTopEl.classList.add("m-scroll-to-top--has-wobbler--has-sticky-button");
                            else
                                scrollToTopEl.classList.add("m-scroll-to-top--has-sticky-button");
                        }
                        else {
                            if (wobblerEl) {
                                scrollToTopEl.classList.remove("m-scroll-to-top--has-wobbler--has-sticky-button");
                                scrollToTopEl.classList.add("m-scroll-to-top--has-wobbler");
                            }
                            else {
                                scrollToTopEl.classList.remove("m-scroll-to-top--has-sticky-button");
                            }
                        }
                        setBottomStyle();
                    };
                    window.addEventListener("scroll", () => {
                        handleScroll();
                    });
                    const debouncedResize = eXpress.utils.debounce(onResize, 100);
                    window.addEventListener("resize", debouncedResize);
                    scrollToTopEl.addEventListener("click", () => {
                        window.scrollTo({ top: 0, behavior: "smooth" });
                        if (isIOS())
                            eXpress.utils.debounce(() => {
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            }, 100);
                    });
                    updateProgress();
                    setBottomStyle();
                };
                init();
            });
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initSearchBar(desktopSearchBarContainer, mobileSearchBarContainer, autoCompleteSearch, onOpen, onClose) {
                const initAutoComplete = (buttonEl, inputEl, clearSearchButtonEl) => {
                    const buttonDisabledClass = "a-action--disabled";
                    const form = inputEl.parentElement;
                    if (buttonEl)
                        buttonEl.classList.add(buttonDisabledClass);
                    const renderTextWithHighlights = (item, currentSearchterm) => {
                        currentSearchterm = currentSearchterm.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                        const re = new RegExp("(" + currentSearchterm.split(' ').join('|') + ")", "gi");
                        const value = item.value.replace(re, "<span class='u-color-style--blue-500'>$1</span>");
                        return `<span class"a-typography a-typography--remarks">${value}</span>`;
                    };
                    buttonEl.onkeyup = (ev) => {
                        if (ev.key === "Enter") {
                            if (inputEl && inputEl.value && validateInput(inputEl)) {
                                form.submit();
                            }
                            else {
                                inputEl.focus();
                            }
                        }
                    };
                    clearSearchButtonEl.addEventListener("click", () => {
                        inputEl.value = "";
                        clearSearchButtonEl.classList.add("u-hide");
                        buttonEl && buttonEl.classList.toggle(buttonDisabledClass, !inputEl.value);
                    });
                    inputEl.onkeyup = function () {
                        clearSearchButtonEl && clearSearchButtonEl.classList.toggle("u-hide", !inputEl.value.length);
                        buttonEl && buttonEl.classList.toggle(buttonDisabledClass, !inputEl.value);
                    };
                    form.onsubmit = function (e) {
                        if (!inputEl || !inputEl.value || !validateInput(inputEl)) {
                            e.preventDefault();
                            return;
                        }
                        inputEl.value = inputEl.value.replace(/[<>]+/g, '');
                    };
                    return main.createTextInputWithAutoComplete(inputEl, {
                        onSelect: () => { onClose && onClose(); form.submit(); },
                        autoCompleteSearch: (searchterm) => {
                            if (validateInput(inputEl, searchterm))
                                return autoCompleteSearch(searchterm).then(res => res.map(item => ({ value: item, label: item })));
                            return $.Deferred();
                        },
                        onOpen: onOpen,
                        onClose: onClose,
                        renderTextContent: renderTextWithHighlights,
                        containerClass: 'm-suggestion-list m-search-bar__suggestion-list technical-autocomplete-suggestions',
                        containerInsertPosition: 'afterend',
                    });
                };
                const validateInput = (inputEl, searchTerm) => {
                    return eXpress.utils.isValidTextWithoutAngleBrackets(searchTerm ? searchTerm : inputEl.value);
                };
                const initMobileSearchBar = (containerEl) => {
                    const inputEl = eXpress.html.querySelector(containerEl, ".m-search-bar__input", true);
                    const buttonEl = eXpress.html.querySelector(containerEl, ".technical-search", true);
                    const clearSearchButtonEl = eXpress.html.querySelector(containerEl, ".technical-clear-search", true);
                    const autoComplete = initAutoComplete(buttonEl, inputEl, clearSearchButtonEl);
                    const onSearchTooltipOpen = () => inputEl.focus();
                    const form = inputEl.parentElement;
                    form.onsubmit = function (e) {
                        if (!inputEl || !inputEl.value || !validateInput(inputEl)) {
                            e.preventDefault();
                            return;
                        }
                        inputEl.value = inputEl.value.replace(/[<>]+/g, '');
                    };
                    const overlayComponent = components.main.initTooltip({
                        buttonEl: containerEl.previousElementSibling,
                        containerEl: containerEl,
                        onOpen: onSearchTooltipOpen,
                        openClass: "menu-is-open",
                        tooltipSelector: ".technical-mobile-searchbar",
                        toggleIconSelector: ".icon-search_thin"
                    });
                    return {
                        dispose: () => {
                            overlayComponent.dispose();
                            autoComplete.dispose();
                        }
                    };
                };
                // init desktop search autocomplete
                const desktopSearchBar = initAutoComplete(eXpress.html.querySelector(desktopSearchBarContainer, '.technical-search', true), eXpress.html.querySelector(desktopSearchBarContainer, '.m-search-bar__input', true), eXpress.html.querySelector(desktopSearchBarContainer, '.technical-clear-search', true));
                // init mobile search
                const mobileSearchBar = initMobileSearchBar(mobileSearchBarContainer);
                return {
                    dispose: () => {
                        mobileSearchBar.dispose();
                        desktopSearchBar.dispose();
                    }
                };
            }
            main.initSearchBar = initSearchBar;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            eXpress.html.querySelectorAll(document, ".skeleton-loading img").forEach(img => {
                const removeSkeleton = () => {
                    const parent = eXpress.html.getParentWithClassName(img, "skeleton-loading");
                    if (parent)
                        parent.classList.remove("skeleton-loading");
                };
                if (img.complete) {
                    removeSkeleton();
                }
                else {
                    img.addEventListener("load", () => { removeSkeleton(); });
                }
            });
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function createExternalInlineLogin(containerEl, deps, authenticatedCallback = null) {
                const googleLoginButtonEl = eXpress.html.querySelector(containerEl, ".technical-button-google-login", false);
                const googleAppid = googleLoginButtonEl && googleLoginButtonEl.dataset.appid || undefined;
                const facebookLoginButtonEl = eXpress.html.querySelector(containerEl, ".technical-button-facebook-login", false);
                const { onOrderFlow } = deps;
                const loginUserAtSmartPhoto = (uid, accessToken, expire, mediaStorePartnerType, newEmail, skipLogin, async, onOrderFlow, scope, idToken) => {
                    const loginUserAtSmartPhotoPromise = $.ajax({
                        url: '/ajaxxhr/Login/LoginUserAtSmartPhoto',
                        type: 'POST',
                        global: false,
                        contentType: 'application/json; charset=utf-8',
                        data: '{' +
                            '"userId": "' + uid + '", ' +
                            '"accessToken": "' + accessToken + '", ' +
                            '"expire": "' + expire + '", ' +
                            '"mediastorePartnerType": "' + mediaStorePartnerType + '", ' +
                            '"newEmail": "' + newEmail + '", ' +
                            '"skipLogin": "' + skipLogin + '", ' +
                            '"onOrderFlow": "' + onOrderFlow + '", ' +
                            '"async": "' + async + '", ' +
                            '"scope": "' + scope + '", ' +
                            '"idToken": "' + idToken +
                            '}',
                        dataType: 'json',
                    })
                        .then(res => res);
                    return eXpress.utils.showLoadingDialog(loginUserAtSmartPhotoPromise)
                        .then(res => handleExternalLoginResult(res, mediaStorePartnerType, async, onOrderFlow, undefined, undefined, undefined, undefined, uid, accessToken));
                };
                /* End All API calls */
                const handleExternalLoginResult = (response, mediaStorePartnerType, async, onOrderFlow, accountId = "", tempAccountId = "", showConfirmationBeforeRedirect = false, loginNotCorrect = false, uid = "", accessToken = "", idToken = "", scope = "", expire = 0) => {
                    const ssoConfirmationDialog = (email, mediaStorePartnerType, okFunction) => {
                        // COnfirmation popup -> through deps
                    };
                    let loginUserAtSmartPhotoResponse = undefined;
                    let loginResult = undefined;
                    if (isLoginUserAtSmartPhotoResponse(response))
                        loginUserAtSmartPhotoResponse = response;
                    else
                        loginResult = response;
                    let asyncSuccess = true;
                    if (async) {
                        if (loginResult && loginResult.success == 'true') {
                            asyncSuccess = false;
                        }
                    }
                    if (async && asyncSuccess && loginUserAtSmartPhotoResponse) {
                        loginResult = loginUserAtSmartPhotoResponse.loginResult;
                    }
                    if (asyncSuccess && loginResult && loginResult.success == 'true') {
                        if (async) {
                            // Success !
                            if (authenticatedCallback)
                                authenticatedCallback();
                        }
                        else {
                            let okFunction;
                            if (loginResult.redirectUrl) {
                                const url = loginResult.redirectUrl;
                                okFunction = window.setTimeout(function () {
                                    window.location.replace(url);
                                }, 0);
                            }
                            if (showConfirmationBeforeRedirect)
                                ssoConfirmationDialog(loginResult.Email, mediaStorePartnerType, okFunction);
                            else
                                okFunction();
                        }
                    }
                    else if (loginResult) {
                        // We need to correct the result for TEMP accounts (only Popupcase and success are returned)
                        if (!loginResult.AccountId && accountId)
                            loginResult.AccountId = accountId;
                        if (!loginResult.tempAccountId && tempAccountId)
                            loginResult.tempAccountId = tempAccountId;
                        handleLoginFailed(loginResult, mediaStorePartnerType, loginNotCorrect, async, onOrderFlow, mediaStorePartnerType, uid, accessToken, idToken, scope, expire);
                    }
                };
                const handleLoginFailed = (loginResult, mediaStorePartnerType, loginNotCorrect, async, onOrderFlow, mediaStorePartnerLabel, uid = "", accessToken = "", idToken = "", scope = "", expire = 0, skipLogin = false) => {
                    const alreadyTriedNewEmail = false;
                    const popUpCase = loginResult.PopUpCase;
                    let otherEmailDialogTriggered = 0;
                    let accountInOtherDomainCalled = 0;
                    switch (popUpCase) {
                        case "AccountBlocked":
                            deps.popups.accountBlockedDialog();
                            break;
                        case "AskPassword":
                            deps.popups.askPasswordDialog(loginResult.AccountId, loginResult.tempAccountId, mediaStorePartnerType, loginNotCorrect, alreadyTriedNewEmail, async, onOrderFlow, mediaStorePartnerLabel, handleExternalLoginResult);
                            break;
                        case "AlreadyLoggedIn":
                            deps.popups.allReadyLoggedInDialog();
                            break;
                        case "FatalErrorMessage":
                            deps.popups.fatalErrorDialog(mediaStorePartnerLabel);
                            break;
                        case "ConfirmEmail":
                            deps.popups.confirmEmailDialog(loginResult.Email, loginResult.tempAccountId, mediaStorePartnerType, mediaStorePartnerLabel);
                            break;
                        case "OtherEmail":
                            deps.popups.otherEmailDialog(loginResult.AccountId, uid, accessToken, expire, otherEmailDialogTriggered > 0, skipLogin, async, onOrderFlow, mediaStorePartnerLabel, (uid, accessToken, expire, mediaStorePartnerType, newEmail, skipLogin, async, onOrderFlow) => loginUserAtSmartPhoto(uid, accessToken, expire, mediaStorePartnerType, newEmail, skipLogin, async, onOrderFlow, scope, idToken), mediaStorePartnerType);
                            otherEmailDialogTriggered++;
                            break;
                        case "FbIdAlreadyConnected":
                            deps.popups.fbIdAlreadyConnected(mediaStorePartnerLabel);
                            break;
                        case "AccountInOtherDomain":
                            deps.popups.accountInOtherDomainDialog(loginResult.AccountId, uid, accessToken, expire, accountInOtherDomainCalled > 0, skipLogin, async, onOrderFlow, (uid, accessToken, expire, mediaStorePartnerType, newEmail, skipLogin, async, onOrderFlow) => loginUserAtSmartPhoto(uid, accessToken, expire, mediaStorePartnerType, newEmail, skipLogin, async, onOrderFlow, scope, idToken), mediaStorePartnerType);
                            accountInOtherDomainCalled++;
                            break;
                        case "ShowNewsletter":
                            deps.popups.showNewsletterPopup(loginResult.PersonId, loginResult.redirectUrl);
                            break;
                        default:
                            deps.popups.generalErrorDialog(mediaStorePartnerLabel);
                            break;
                    }
                };
                const isLoginUserAtSmartPhotoResponse = (response) => {
                    if (!response) {
                        return false;
                    }
                    return response.loginResult;
                };
                const init = () => {
                    if (googleLoginButtonEl && googleAppid) {
                        components.main.createGoogleLogin(googleLoginButtonEl, onOrderFlow, {
                            appId: googleAppid,
                            handleExternalLoginResult: (response, mediaStorePartnerType, async, onOrderFlow, idToken = "", scope = "") => handleExternalLoginResult(response, mediaStorePartnerType, async, onOrderFlow, undefined, undefined, undefined, undefined, undefined, idToken, scope, undefined),
                        });
                    }
                    // init facebook login main
                    if (facebookLoginButtonEl) {
                        components.main.createFacebookLoginButton(facebookLoginButtonEl, onOrderFlow, {
                            handleExternalLoginResult: (response, mediaStorePartnerType, async, onOrderFlow, userId, accessToken, scope, expiresIn) => handleExternalLoginResult(response, mediaStorePartnerType, async, onOrderFlow, undefined, undefined, false, false, userId, accessToken, undefined, scope, expiresIn),
                        });
                    }
                };
                init();
            }
            main.createExternalInlineLogin = createExternalInlineLogin;
            function createStandardInlineRegister(containerEl, formEl, deps, redirectUrl = null, authenticatedCallback = null) {
                const newsletterEl = eXpress.html.querySelector(containerEl, ".technical-newsletter", true);
                const personalMessageEl = eXpress.html.querySelector(containerEl, ".technical-personal-message", true);
                const register = (email, password, newsletter, personalMessage) => $.ajax({
                    url: "/ajaxxhr/Login/Registration",
                    type: "POST",
                    data: {
                        Email: email,
                        Password: password,
                        Newsletter: newsletter,
                        PersonalMessage: personalMessage,
                        redirectUrl: redirectUrl
                    }
                })
                    .then(res => res);
                const handleRegisterResult = (result, setError) => {
                    if (result.success && result.redirectUrl) {
                        window.history.replaceState({}, document.title, result.redirectUrl);
                        window.location.replace(result.redirectUrl + "?success=true");
                    }
                    if (!result.success && result.message) {
                        setError('password', result.message);
                    }
                };
                const onSubmitRegisterForm = (formData) => {
                    return eXpress.utils.showLoadingDialog(register(formData["email"], formData["password"], newsletterEl.checked, personalMessageEl.checked)
                        .then(res => {
                        handleRegisterResult(res, setError);
                    }));
                };
                const setError = (name, error) => registerForm.setErrors(false, { name, error });
                const registerForm = components.main.initForm(formEl, {
                    onSubmitForm: onSubmitRegisterForm,
                    buttonSelector: ".technical-register-button"
                });
                const init = () => {
                    createExternalInlineLogin(containerEl, deps, authenticatedCallback);
                };
                init();
            }
            main.createStandardInlineRegister = createStandardInlineRegister;
            function createStandardInlineLogin(containerEl, formEl, deps, redirectUrl = null, authenticatedCallback = null) {
                const closeButton = eXpress.html.querySelector(containerEl, '.technical-login-close', true);
                const forgotPasswordButton = eXpress.html.querySelector(containerEl, '.technical-login-forgot-button', true);
                /* All API calls
                 *
                 * Note: Normally, our components do not include API calls.
                 * However, this is a super component that features the standard login in all situations with the same API calls.
                 */
                const login = (email, password) => $.ajax({
                    url: "/ajaxxhr/Login/NormalLogin",
                    type: "POST",
                    data: {
                        Email: email,
                        PassWord: eXpress.utils.stringToBase64(password),
                        redirectUrl: redirectUrl
                    }
                })
                    .then(res => res);
                const forgotPassword = (email) => $.ajax({
                    url: "/ajaxxhr/Login/ForgotPassword",
                    type: "POST",
                    data: {
                        email
                    }
                }).then(res => res);
                /* End All API calls */
                const handleLoginResult = (result, setError) => {
                    if (!result.isNotAuthenticated && !result.blockingErrorMsg) {
                        if (result.redirectUrl) {
                            window.history.replaceState({}, document.title, result.redirectUrl);
                            window.location.replace(result.redirectUrl + "?success=true");
                        }
                        else if (authenticatedCallback)
                            authenticatedCallback();
                    }
                    else {
                        if (result.blockingErrorMsg && deps.showTopMessage)
                            deps.showTopMessage(components.main.PageLogStyle.Error, result.blockingErrorMsg);
                        if (result.isNotAuthenticated && !result.blockingErrorMsg)
                            setError('password', result.errorMsg ? result.errorMsg : 'Something went wrong');
                    }
                };
                const onSubmitLoginForm = (formData) => {
                    return eXpress.utils.showLoadingDialog(login(formData["email"], formData["password"])
                        .then(res => {
                        handleLoginResult(res, setError);
                    }));
                };
                const setError = (name, error) => loginForm.setErrors(false, { name, error });
                const loginForm = components.main.initForm(formEl, {
                    onSubmitForm: onSubmitLoginForm,
                    buttonSelector: ".technical-login-button"
                });
                const closeLogin = () => {
                    if (deps.hideTopMessage)
                        deps.hideTopMessage();
                    if (deps.close)
                        deps.close();
                    else
                        containerEl.classList.add('u-hide');
                };
                const eventDisposables = eXpress.utils.compositeDisposable([
                    eXpress.html.addEventListener(closeButton, 'click', closeLogin),
                    eXpress.html.addEventListener(forgotPasswordButton, 'click', deps.showForgotPasswordPopup)
                ]);
                const hideCloseButton = () => {
                    closeButton.classList.add('u-hide');
                };
                const disableInput = (inputName) => {
                    loginForm.disableInput(inputName);
                };
                const init = () => {
                    createExternalInlineLogin(containerEl, deps, authenticatedCallback);
                };
                init();
                return {
                    dispose: () => {
                        eventDisposables.dispose();
                    },
                    forgotPassword: forgotPassword,
                    hideCloseButton: hideCloseButton,
                    disableInput: disableInput
                };
            }
            main.createStandardInlineLogin = createStandardInlineLogin;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function CreateTabs(container) {
                const tabsCollectionContainer = eXpress.html.querySelector(container, '.m-tabs', true);
                const tabHideClass = tabsCollectionContainer.dataset.hideclass || 'u-hide';
                const init = () => {
                    updateTab(tabHideClass, location.hash.substring(1)); // begin from 1 to avoid the #
                    addEventListenerToTabs();
                };
                const addEventListenerToTabs = () => {
                    // make tabs click-able
                    const tabEls = eXpress.html.querySelectorAll(tabsCollectionContainer, '.m-tabs__input');
                    for (let i = 0; i < tabEls.length; i++)
                        tabEls[i].addEventListener('change', (e) => updateTab(tabHideClass, e.target.dataset.url));
                    // if hash change do update content tabs => only triggers by pop state(arrow back in browser)
                    window.addEventListener('hashchange', () => updateTab(tabHideClass, location.hash.substring(1), false));
                };
                // update tab content visibility
                const updateTab = (hideclass, hash, pushNewHash = true) => {
                    const tabToSelect = hash ? eXpress.html.querySelector(tabsCollectionContainer, `input[data-url="${hash}"]`, false) : undefined;
                    const tabEls = eXpress.html.querySelectorAll(tabsCollectionContainer, '.m-tabs__input');
                    const tabContentEls = eXpress.html.querySelectorAll(tabsCollectionContainer, '.m-tabs__content');
                    for (let z = 0; z < tabEls.length; z++) {
                        // set check if selected tab
                        tabEls[z].checked = (tabEls[z] === tabToSelect || (!tabToSelect && z === 0));
                        // hide/unhide content selected tab
                        tabContentEls[z].classList.toggle(hideclass || 'u-hide', !tabEls[z].checked);
                        // push new # to the url bar
                        if (tabEls[z].checked && pushNewHash && tabToSelect)
                            window.history.pushState({}, document.title, `#${hash}`);
                    }
                };
                init();
            }
            main.CreateTabs = CreateTabs;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            let AddressAutocompletionType;
            (function (AddressAutocompletionType) {
                AddressAutocompletionType[AddressAutocompletionType["None"] = 0] = "None";
                AddressAutocompletionType[AddressAutocompletionType["Address"] = 1] = "Address";
                AddressAutocompletionType[AddressAutocompletionType["City"] = 2] = "City";
                AddressAutocompletionType[AddressAutocompletionType["Street"] = 3] = "Street";
                AddressAutocompletionType[AddressAutocompletionType["StreetNumber"] = 4] = "StreetNumber";
            })(AddressAutocompletionType = main.AddressAutocompletionType || (main.AddressAutocompletionType = {}));
            main.autocompleteAddressAsync = (street, number, zip, city, countryCode, autocompletionType, maxNrOfSuggestions) => __awaiter(this, void 0, void 0, function* () {
                if (street.length < 5)
                    return undefined;
                if (zip.length <= 0 || city.length <= 0)
                    return undefined;
                if (["BEL", "NLD", "CHE"].indexOf(countryCode) == -1)
                    return undefined;
                const url = "/apicore/delivery/autocompleteaddress";
                const body = {
                    street,
                    number,
                    zip,
                    city,
                    countryCode,
                    autocompletionType,
                    maxNrOfSuggestions,
                };
                const response = yield fetch(url, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body),
                });
                try {
                    return yield response.json();
                }
                catch (e) {
                    return undefined;
                }
                ;
            });
            main.validateAddressAsync = (street, nr, zip, city, country, deps) => __awaiter(this, void 0, void 0, function* () {
                if (street.length < 3) {
                    return undefined;
                }
                const serverfetch = function (obj) {
                    return __awaiter(this, void 0, void 0, function* () {
                        const nlUrl = '/ajaxxhr/Delivery/ValidateAddress';
                        const rawResponse = yield fetch(nlUrl, {
                            method: 'POST',
                            headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(obj),
                        }).catch((res) => {
                            return deps && deps.logError ? deps.logError(res.toString(), nlUrl, "w3wp").catch(_ => undefined) : undefined;
                        });
                        return rawResponse ? yield rawResponse.json() : undefined;
                    });
                };
                const server = () => {
                    if (zip.length <= 0 || city.length <= 0)
                        return undefined;
                    const obj = {
                        street: street,
                        nr: nr,
                        zip: zip,
                        city: city,
                        country: country
                    };
                    return serverfetch(obj).then(content => {
                        if (content) {
                            const result = {
                                street: content.street,
                                nr: content.nr,
                                zip: content.zip,
                                city: content.city
                            };
                            return result;
                        }
                        else
                            return undefined;
                    }).catch(() => {
                        return undefined;
                    });
                };
                if (country === "BEL" || country === "NLD" || country === 'CHE')
                    return server();
                else
                    return undefined;
            });
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
var eXpress;
(function (eXpress) {
    var components;
    (function (components) {
        var main;
        (function (main) {
            function initTooltip(options) {
                const { buttonEl, containerEl, onOpen, onClose, openClass, tooltipSelector, toggleIconSelector, useCapture = false } = options;
                const closeToolTip = () => {
                    containerEl.classList.remove(openClass || "is-tooltip-open");
                    if (onClose)
                        onClose();
                    document.removeEventListener("click", onDocumentClick);
                };
                const openToolTip = () => {
                    containerEl.classList.add(openClass || "is-tooltip-open");
                    if (onOpen)
                        onOpen(containerEl);
                    document.addEventListener("click", onDocumentClick, { capture: useCapture });
                };
                const onButtonClick = (e) => {
                    containerEl.classList.contains(openClass || "is-tooltip-open")
                        ? closeToolTip()
                        : openToolTip();
                };
                const onDocumentClick = (e) => {
                    const selector = (tooltipSelector || ".technical-price-tooltip") + ", " + (toggleIconSelector || ".technical-price-info-icon");
                    if (!e.target.closest(selector)) {
                        closeToolTip();
                    }
                };
                //open tooltip + function
                buttonEl.addEventListener("click", onButtonClick);
                const dispose = () => {
                    buttonEl.removeEventListener("click", onButtonClick);
                    document.removeEventListener("click", onDocumentClick);
                };
                return {
                    dispose,
                    closeToolTip
                };
            }
            main.initTooltip = initTooltip;
        })(main = components.main || (components.main = {}));
    })(components = eXpress.components || (eXpress.components = {}));
})(eXpress || (eXpress = {}));
